import {GadgetId} from './gadget-id';
import { MaterialId } from './gadget-material-id';

// NewOrderConst
export class NOC {}
export default NOC;

// Charts用の定数
export namespace NOC.CHARTS {
  export const BAR = 'bar-chart';
  export const LINE = 'line-chart';
  export const PIE = 'pie-chart';
  export const RADAR = 'radar-chart';
  export const BUBBLE = 'bubble-chart';
  export const DOUGHNUT = 'doughnut-chart'; // ドーナツ円グラフ
  export const LIST = 'list';
  export const HORIZONTALBAR = 'horizontalbar-chart';
  export const STACKED_BAR = 'stacked-bar-chart';
  export const STACKED_HORIZONTALBAR = 'stacked-horizontal-bar-chart';
  export const POLARAREA = 'polar-chart';
  export const SCATTER = 'scatter-chart';
  export const HEATMAP = 'heatmap-chart';
  export const ALL = 'all';
}


export namespace NOC.CHEKBOX {
  export const TRUE = 'true';
  export const FALSE = 'false';
}

export namespace NOC.SETTING.ROLE {
  export const ALL = '全員';
  export const MANAGER = '労務管理者';
  export const GENERAL = '一般';
  export const ADMIN = 'アカウント管理者';
}

export namespace NOC.SETTING.ROLE.VALUE {
  export const NONE = 0;
  export const ADMIN = 1;
  export const MANAGER = 2;
  export const GENERAL = 3;
  export const ALL = 99;
}

export namespace NOC.SETTING.GENDER {
  export const MAN = '男性';
  export const WOMAN = '女性';
  export const OTHER = 'その他';
}

export namespace NOC.SETTING.GENDER.VALUE {
  export const MAN = 1;
  export const WOMAN = 2;
  export const OTHER = 3;
}

export namespace NOC.SETTING.FLEXTIME {
  export const OFF = 'なし';
  export const ON = 'あり';
}

export namespace NOC.SETTING.FLEXTIME.VALUE {
  export const OFF = 0;
  export const ON = 1;
}

export namespace NOC.SETTING.STATUS {
  export const FREE = 'free';
  export const AVERAGE = 'average';
  export const BUSY = 'busy';
  export const VERYBUSY = 'veryBusy';
}

export namespace NOC.SETTING.BLACKLIST {
  export const BLACK = 1;
  export const WHITE = 2;
  export const NOTESET = 0;
}

export namespace NOC.SELECT {
  export const FIRST = {text: '未登録', value: 0};
  export const NOSELECT = {text: '未選択', value: 0};
  export const NOSELECT_LONG = {text: '選択してください', value: 0};
  export const ALL_DEPARTMENTS = {text: 'すべての部署', value: 0};
  export const ALL_WORKSTYLES = {text: 'すべての就業形態', value: 0};
}

export namespace NOC.SETTING.HOLIDAY {
  export const MON = '月';
  export const TUE = '火';
  export const WED = '水';
  export const THU = '木';
  export const FRI = '金';
  export const SAT = '土';
  export const SUN = '日';
  export const JAPAN = '祝日';
}


export namespace NOC.SETTING.HOLIDAY.VALUE {
  export const MON = '1';
  export const TUE = '2';
  export const WED = '3';
  export const THU = '4';
  export const FRI = '5';
  export const SAT = '6';
  export const SUN = '0';
  export const JAPAN = '7';
}



export namespace NOC.SETTING.CUTOFFDAY {
  export const DAYS5 = '5日締め';
  export const DAYS10 = '10日締め';
  export const DAYS15 = '15日締め';
  export const DAYS20 = '20日締め';
  export const DAYS25 = '25日締め';
  export const LAST = '末日締め';
  export const SELECT = '締め日入力';
}

export namespace NOC.SETTING.CUTOFFDAY.VALUE {
  export const DAYS5 = 5;
  export const DAYS10 = 10;
  export const DAYS15 = 15;
  export const DAYS20 = 20;
  export const DAYS25 = 25;
  export const LAST = 99;
  export const SELECT = 1;
}

export namespace NOC.SETTING.LEGALHOLIDAY {
  export const ONE = '1週1休';
  export const FOUR = '4週4休';
}

export namespace NOC.SETTING.LEGALHOLIDAY.VALUE {
  export const ONE = 1;
  export const FOUR = 4;
}

export namespace NOC.OS {
  export const WINDOWS = 'Windows';
  export const MAC = 'Mac';
  export const ANDROID = 'Android';
}

export namespace NOC.API.RESULUT {
  export const SUCCESS = 'success';
  export const FAIL = null;
}

// アプリケーション< メンバー < 就業形態
// target は複数選択可能

export namespace NOC.GRAPH.MATERIALOLD {
  export const TARGET = ['指定：メンバー', '指定：就業形態', '指定：アプリケーション', '指定：年', '指定：月', '指定：日'];
  export const MEASURE = ['時間：勤務時間', '時間：残業時間', '時間：労働時間', '時間：NG動作時間', '回数：操作数' ];
  export const DIMENSION = ['メンバー毎', '就業形態毎', 'アプリケーション毎', '年毎', '月毎', '日毎'];
}

export namespace NOC.GRAPH.MATERIAL {
  export const TARGET = [
    {key: 'メンバー', category: '1'},
    {key: '就業形態', category: '1'},
    {key: 'アプリケーション', category: '1'},
    {key: '年', category: '2'},
    {key: '月', category: '2'},
    {key: '日', category: '2'},
  ];
  export const MEASURE = [
    {key: '勤務時間', category: '3'},
    {key: '残業時間', category: '4'},
    {key: '労働時間', category: '5'},
    {key: 'NG動作時間', category: '6'},
    {key: '操作数', category: ''},
  ];
  export const DIMENSION = [
    {key: 'メンバー毎', category: '1'},
    {key: '就業形態毎', category: '1'},
    {key: 'アプリケーション毎', category: '1'},
    {key: '年毎', category: '2'},
    {key: '月毎', category: '2'},
    {key: '日毎', category: '2'},
  ];
}



export namespace NOC.N16 {
  export const DIR = 'idh.no';
}

export namespace NOC.APP.MODE {
  export const WELCOME = 'Welcome';
  export const LOGIN = 'Login';
  export const AUTH  = 'Auth';
  export const REJECT = 'Reject';
  export const FORGET = 'Forget';
  export const SIGNUP = 'Signup';
  export const SIGNUP_LOWER = 'signup';
  export const ERROR = 'Error';
  export const CONFIRM = 'Confirm';
  export const INVITATION = 'Invitation';
  export const VERIFICATION = 'Verification';
  export const THANKS = 'Thanks';
  export const CHANGE = 'Change';
  export const CONTACT = 'Contact';
  export const PERSONAL = 'Personal';
  export const TERMS = 'Terms';
  export const NOTATION = 'Notation';
  export const WELCOME_PHONE = 'WelcomePhone';
  export const HELP = 'Help';
  export const COMING = 'Coming';
  export const MAINTENANCE = 'Maintenance';

  // @note takezawa DIRECT の情報はroute.tsのmeta.is_deny_after_loginに移動しました。2026/02/05
  // todo takezawa removeme しばらく問題なければ以下削除。
  // export const DIRECT = [
  //   WELCOME,  // note takezawa このページは使用されていない？
  //   LOGIN,
  //   AUTH,  // note takezawa このページは使用されていない？
  //   FORGET,  // note takezawa このページは使用されていない？
  //   HELP, // note takezawa helpページは存在するがURL直アクセスすると/(ダッシュボード画面)にリダイレクトされるが404でよいのでは？。ここに書くべきではないのでは？
  //   SIGNUP,
  //   SIGNUP_LOWER,
  //   ERROR, // note takezawa 現在はコメントアウトされていて使用されていない模様？
  //   CHANGE,  // note takezawa このページは使用されていない？
  //   CONTACT,  // note takezawa /contact は存在するが、 /Contact は存在しないので、DIRECT.findでヒットしない。
  //   PERSONAL,  // note takezawa ログイン時も、ログイン後も表示するので、ここに書くべきではないのでは？
  //   TERMS,  // note takezawa このページは使用されていない？
  //   NOTATION,  // note takezawa このページは使用されていない？
  //   THANKS,  // note takezawa このページは使用されていない？
  // ];
}

export namespace NOC.CONTRACT {
  export const TRIAL = 'TRIAL';     // お試し期間
  export const REGIST = 'REGIST';   // 登録済み
  export const QUIT = 'QUIT';       // 退会
  export const DELAY = 'DELAY';     // 支払い遅延（サービス停止）
  export const CONFIRM = 'CONFIRM'; // 支払い遅延（猶予期間）。一定期間でDELAYになる。
  export const STOP = 'STOP';       // 停止
  export const DENY = 'DENY';       // 拒否
}

export namespace NOC.PAYMENT {
  export const NOSELECT = 0;
  export const CREDIT = 1;
  export const BANK = 2;
}

export namespace NOC.CREDIT {
  export const CALLBACK_PARAMETER = 'callBack';
  export const THREE_D_SECURE = {
    NULL: null,                // 3Dセキュアなし
    UNVERIFIED: 'unverified',  // 3Dセキュア未実施
    VERIFY: 'verified',        // 認証成功
    ATTEMPTED: 'attempted',    // アテンプト
    FAILED: 'failed',          // 認証失敗
    ERROR: 'error',            // 認証処理エラー
  };
}

export namespace NOC.NOTIFICATION {
  export const UNKNOWN = 0;
  export const PROMOTION = 1;
  export const BILLING = 2;
  export const CREDIT_COMPLETE = 3;
  export const CREDIT_FAILURE = 4;
  export const UNNECESSARY = 99;
}

export namespace NOC.REQUEST.CONFIRM {
  export const UNKNOWN = 0;
  export const CHECKED = 1;
  export const TOOKOVER = 2;
}

/// 以降マージが必要


export namespace NOC.GRAPH.MATERIAL.V2 {
  export const TARGET = '1';
  export const MEASURE = '2';
  export const DIMENSION = '3';
  export const MATERIAL = [
    {id: 1, key: 'メンバー', category: TARGET, reject: [2, 3, 12, 13]},
    {id: 2, key: '就業形態', category: TARGET, reject: [1, 3, 13, 14, 15, 16, 17, 18]},
//    {id: 3, key: 'アプリケーション', category: TARGET, reject: [1, 2, 14]},
    {id: 4, key: '年', category:  TARGET, reject: [5, 6, 15, 18]},
    {id: 5, key: '月', category: TARGET, reject: [4, 6, 15, 16, 18]},
    {id: 6, key: '日', category: TARGET, reject: [4, 5, 8, 15, 16, 17, 19, 20]},
    {id: 7, key: '勤務時間', category: MEASURE, reject: [11]},
    {id: 8, key: '残業時間', category: MEASURE, reject: [11, 18]},
//    {id: 9, key: '労働時間', category: MEASURE, reject: [11]},
//    {id: 10, key: 'NG動作時間', category: MEASURE, reject: [11]},
//    {id: 11, key: '操作数', category: MEASURE, reject: [7, 8, 9, 10]},
    {id: 12, key: 'メンバー毎', category: DIMENSION, reject: [1, 13, 14, 15, 16, 17, 18]},
//    {id: 13, key: '就業形態毎', category: DIMENSION, reject: [1, 2, 12, 14, 15, 16, 17]},
//    {id: 14, key: 'アプリケーション毎', category: DIMENSION, reject: [3, 12, 13, 15, 16, 17, 18]},
    {id: 15, key: '年毎', category: DIMENSION, reject: [2, 4, 5, 6, 12, 13, 14, 16, 17, 18]},
    {id: 16, key: '月毎', category: DIMENSION, reject: [2, 5, 6, 12, 13, 14, 15, 17, 18]},
    {id: 17, key: '日毎', category: DIMENSION, reject: [2, 6, 12, 13, 14, 15, 16, 18]},
    {id: 18, key: '時毎', category: DIMENSION, reject: [2, 4, 5, 8, 12, 13, 14, 15, 16, 17, 19, 20]},
    {id: 19, key: '就業未達成時間', category: MEASURE, reject: [11, 18]},
    {id: 20, key: '就業時間', category: MEASURE, reject: [11, 18]},
  ];
}

export interface IMaterial {
  id: number;
  key: string;
  domain: string;
  reject: number[];
  kingdom?: string;
}

export namespace NOC.MATERIAL.V3 {
  export const DOMAIN = {
    TYPE: 'TYPE',
    TARGET: 'TARGET',
    MEASURE: 'MEASURE',
    DIMENSION: 'DIMENSION',
    COMPARE_TYPE: 'COMPARE_TYPE',
    COMPARE_TARGET: 'COMPARE_TARGET',
    COMPARE_MEASURE: 'COMPARE_MEASURE',
    FLAG: 'FLAG', // 作業用MATERIAL
  };

  export const KINGDOM = {
    SETDATA: 'SETDATA',
    DATE: 'DATE',
  };

  export namespace MATERIAL {
    export const TARGET_MEMBER = {id: 1, key: 'メンバー', domain: DOMAIN.TARGET, reject: [2, 3, 12, 13, 21, 53, 54], kingdom: KINGDOM.SETDATA };
    // export const WORK_STYLE = {id: 2, key: '就業形態', domain: DOMAIN.TARGET, reject: [1, 3, 13, 14, 15, 16, 17, 18], kingdom: KINGDOM.SETDATA};
    // export const APP = {id: 3, key: 'アプリケーション', domain: DOMAIN.TARGET, reject: [1, 2, 14]};
    export const TARGET_YEAR = {id: 4, key: '年', domain:  DOMAIN.TARGET, reject: [5, 6, 15, 18], kingdom: KINGDOM.DATE};
    export const TARGET_MONTH = {id: 5, key: '月', domain: DOMAIN.TARGET, reject: [4, 6, 15, 16, 18], kingdom: KINGDOM.DATE};
    export const TARGET_DATE = {id: 6, key: '日', domain: DOMAIN.TARGET, reject: [4, 5, 8, 15, 16, 17, 19, 20], kingdom: KINGDOM.DATE};
    export const MEASURE_WORKING_TIME = {id: 7, key: '実労働時間', domain: DOMAIN.MEASURE, reject: [24]};
    export const MEASURE_OVER_TIME = {id: 8, key: '残業時間', domain: DOMAIN.MEASURE, reject: [6, 18, 24]};
    // export const A = {id: 9, key: '労働時間', domain: DOMAIN.MEASURE, reject: [11]};
    // export const MEMBER = {id: 10, key: 'NG動作時間', domain: DOMAIN.MEASURE, reject: [11]};
    export const MEASURE_COUNT = {id: 11, key: '操作回数', domain: DOMAIN.MEASURE, reject: [24]};
    export const DIMENSION_MEMBER = {id: 12, key: 'メンバー毎', domain: DOMAIN.DIMENSION, reject: [1, 13, 14, 15, 16, 17, 18]};
    // export const MEMBER = {id: 13, key: '就業形態毎', domain: DOMAIN.DIMENSION, reject: [1, 2, 12, 14, 15, 16, 17]};
    // export const MEMBER = {id: 14, key: 'アプリケーション毎', domain: DOMAIN.DIMENSION, reject: [3, 12, 13, 15, 16, 17, 18]};
    export const DIMENSION_YEAR = {id: MaterialId.DIMENSION_YEAR, key: '年毎', domain: DOMAIN.DIMENSION, reject: [2, 4, 5, 6, 12, 13, 14, 16, 17, 18, 21]};
    export const DIMENSION_MONTH = {id: MaterialId.DIMENSION_MONTH, key: '月毎', domain: DOMAIN.DIMENSION, reject: [2, 5, 6, 12, 13, 14, 15, 17, 18, 21]};
    export const DIMENSION_DATE = {id: MaterialId.DIMENSION_DATE, key: '日毎', domain: DOMAIN.DIMENSION, reject: [2, 6, 12, 13, 14, 15, 16, 18, 21, 34]};
    export const DIMENSION_HOUR = {id: MaterialId.DIMENSION_HOUR, key: '時毎', domain: DOMAIN.DIMENSION, reject: [2, 4, 5, 8, 12, 13, 14, 15, 16, 17, 19, 20, 21, 34]};
    export const MEASURE_UNACHIEVED_TIME = {id: 19, key: '就業未達成時間', domain: DOMAIN.MEASURE, reject: [6, 18, 24]};
    export const MEASURE_SETTING_TIME = {id: 20, key: '就業時間', domain: DOMAIN.MEASURE, reject: [6, 18, 24]};
    export const DIMENSION_GROUP = {id: 21, key: 'グループ', domain: DOMAIN.TARGET,  reject: [1, 2, 3, 21, 15, 16, 17, 18, 53, 54], kingdom: KINGDOM.SETDATA };
    export const TARGET_ALL = {id: 22, key: '複数人', domain: DOMAIN.TARGET,  reject: [1, 2, 3, 18, 21, 27, 53, 54], kingdom: KINGDOM.SETDATA };
    export const MEASURE_INTERVAL_TIME = {id: 23, key: 'インターバル時間', domain: DOMAIN.MEASURE, reject: [18, 24]};
    export const MEASURE_APP = {id: 24, key: 'アプリ', domain: DOMAIN.MEASURE, reject: [7, 8, 11, 19, 20, 23, 36]};
    export const TYPE_SUM = {id: 25, key: '集計グラフ', domain: DOMAIN.TYPE, reject: [26]};
    export const TYPE_AVERAGE = {id: 26, key: '平均グラフ', domain: DOMAIN.TYPE, reject: [17, 18, 25]};
    export const TARGET_GROUP_MULTI = {id: 27, key: '複数グループ', domain: DOMAIN.TARGET, reject: [1, 2, 3, 18, 21, 22, 53, 54], kingdom: KINGDOM.SETDATA};
    export const FLAG_GROUP_MEMBER = {id: 28, key: '_グループメンバー毎_', domain: DOMAIN.FLAG, reject: []};

    export const COMPARE_TARGET_MEMBER = {id: MaterialId.COMPARE_TARGET_MEMBER, key: '個人', domain: DOMAIN.COMPARE_TARGET, reject: [30, 31, 32, 55], kingdom: KINGDOM.SETDATA };
    export const COMPARE_TARGET_GROUP = {id: MaterialId.COMPARE_TARGET_GROUP, key: 'グループ', domain: DOMAIN.COMPARE_TARGET,  reject: [29, 31, 32, 55], kingdom: KINGDOM.SETDATA };
    export const COMPARE_TARGET_COMPANY = {id: MaterialId.COMPARE_TARGET_COMPANY, key: '全社', domain: DOMAIN.COMPARE_TARGET,  reject: [29, 30, 32, 55] };
    export const COMPARE_TARGET_ALL = {id: MaterialId.COMPARE_TARGET_ALL, key: '全国', domain: DOMAIN.COMPARE_TARGET,  reject: [29, 30, 31, 55] };
    export const COMPARE_TYPE_SUM = {id: 33, key: '集計', domain: DOMAIN.COMPARE_TYPE, reject: [34] };
    export const COMPARE_TYPE_AVERAGE = {id: 34, key: '平均', domain: DOMAIN.COMPARE_TYPE, reject: [17, 18, 33]};
    export const MEASURE_LOGING_TIME = {id: 36, key: '就業時間', domain: DOMAIN.MEASURE, reject: [24]};

    export const COMPARE_MEASURE_LOGING_TIME = {id: 37, key: '就業時間', domain: DOMAIN.COMPARE_MEASURE, reject: [41]};
    export const COMPARE_MEASURE_WORKING_TIME = {id: 38, key: '実労働時間', domain: DOMAIN.COMPARE_MEASURE, reject: [41]};
    export const COMPARE_MEASURE_OVER_TIME = {id: 39, key: '残業時間', domain: DOMAIN.COMPARE_MEASURE, reject: [6, 18, 41]};
    export const COMPARE_MEASURE_INTERVAL_TIME = {id: 40, key: 'インターバル時間', domain: DOMAIN.COMPARE_MEASURE, reject: [18, 41]};
    export const COMPARE_MEASURE_APP = {id: 41, key: 'アプリ', domain: DOMAIN.COMPARE_MEASURE, reject: [37, 38, 39, 40, 42, 61]};
    export const COMPARE_MEASURE_COUNT = {id: 42, key: '操作回数', domain: DOMAIN.COMPARE_MEASURE, reject: [41]};

    export const FLAG_MULTI_MEMBER = {id: 43, key: '_選択無しメンバー毎_', domain: DOMAIN.FLAG, reject: []};
    export const DIMENSION_DAYS_HOUR = {id: MaterialId.DIMENSION_DAYS_HOUR, key: '_24H超え時毎_', domain: DOMAIN.DIMENSION, reject: []};
    export const FLAG_ALERT_GRAPH = {id: 45, key: '_アラートグラフ_', domain: DOMAIN.FLAG, reject: []};
    // export const FLAG_LEGAL_HOLIDAY_4 = {id: 46, key: '_4週4休_', domain: DOMAIN.FLAG, reject: []};
    export const DIMENSION_36_MONTH = {id: MaterialId.DIMENSION_36_MONTH, key: '_起算日から月毎_', domain: DOMAIN.DIMENSION, reject: []};
    export const MEASURE_OVER_TIME_AGREED = {id: 48, key: '所定労働時間外', domain: DOMAIN.MEASURE, reject: []};
    export const MEASURE_OVER_TIME_LEGAL_1 = {id: 49, key: '法定労働時間外', domain: DOMAIN.MEASURE, reject: []};
    export const MEASURE_OVER_TIME_LEGAL_4 = {id: 50, key: '法定労働時間外', domain: DOMAIN.MEASURE, reject: []};
    export const MEASURE_OVER_TIME_AGREED_FLEX = {id: 51, key: '所定労働時間外', domain: DOMAIN.MEASURE, reject: []};
    export const MEASURE_OVER_TIME_LEGAL_FLEX = {id: 52, key: '法定労働時間外', domain: DOMAIN.MEASURE, reject: []};

    export const MEASURE_36_STATUS = {id: 56, key: '36協定状況', domain: DOMAIN.MEASURE, reject: []};
    export const MEASURE_36_VIOLATION = {id: 57, key: '36協定違反', domain: DOMAIN.MEASURE, reject: []};
    export const MEASURE_BANNED_APP_LIST = {id: 58, key: '禁止アプリ利用者リスト', domain: DOMAIN.MEASURE, reject: []};
    export const MEASURE_BANNED_APP = {id: 59, key: '禁止アプリ利用時間', domain: DOMAIN.MEASURE, reject: []};
    export const COMPARE_MEASURE_BANNED_APP = {id: 60, key: '禁止アプリ利用時間', domain: DOMAIN.COMPARE_MEASURE, reject: []};

    export const COMPARE_MEASURE_UNACHIEVED_TIME = {id: 61, key: '就業未達成時間', domain: DOMAIN.COMPARE_MEASURE, reject: [18, 41]};
    export const MEASURE_OP_COUNT_HEATMAP = {id: MaterialId.MEASURE_OP_COUNT_HEATMAP, key: '操作回数ヒートマップ', domain: DOMAIN.MEASURE, reject: []};
    export const DIMENSION_DAY_OF_WEEK = {id: MaterialId.DIMENSION_DAY_OF_WEEK, key: '曜日毎', domain: DOMAIN.DIMENSION, reject: []};
  }

  export const MATERIALS = [
    MATERIAL.TARGET_MEMBER,
    MATERIAL.TARGET_YEAR,
    MATERIAL.TARGET_MONTH,
    MATERIAL.TARGET_DATE,
    MATERIAL.MEASURE_WORKING_TIME,
    MATERIAL.MEASURE_OVER_TIME,
    MATERIAL.DIMENSION_MEMBER,
    MATERIAL.DIMENSION_YEAR,
    MATERIAL.DIMENSION_MONTH,
    MATERIAL.DIMENSION_DATE,
    MATERIAL.DIMENSION_HOUR,
    MATERIAL.DIMENSION_GROUP,
    MATERIAL.MEASURE_UNACHIEVED_TIME,
    MATERIAL.MEASURE_SETTING_TIME,
  ] as IMaterial[];

  export namespace MATERIAL_BETA { // 第三次デザイン
    // keyとrejectのみ異なる
    export const TARGET_MEMBER = {id: 1, key: '個人', domain: DOMAIN.TARGET, reject: [2, 3, 12, 13, 21, 22, 27, 28, 53, 54], kingdom: KINGDOM.SETDATA };
    export const MEASURE_WORKING_TIME = {id: 7, key: '実労働時間', domain: DOMAIN.MEASURE, reject: [24]};
    export const DIMENSION_YEAR = {id: 15, key: '年', domain: DOMAIN.DIMENSION, reject: [2, 4, 5, 6, 12, 13, 14, 16, 17, 18]};
    export const DIMENSION_MONTH = {id: 16, key: '月', domain: DOMAIN.DIMENSION, reject: [2, 5, 6, 12, 13, 14, 15, 17, 18]};
    export const DIMENSION_DATE = {id: 17, key: '日', domain: DOMAIN.DIMENSION, reject: [2, 6, 12, 13, 14, 15, 16, 18, 26, 28, 34]};
    export const DIMENSION_HOUR = {id: 18, key: '時', domain: DOMAIN.DIMENSION, reject: [2, 4, 5, 8, 12, 13, 14, 15, 16, 17, 19, 20, 22, 23, 26, 27, 34, 39, 40, 61]};
    export const DIMENSION_GROUP = {id: 21, key: 'グループ', domain: DOMAIN.TARGET,  reject: [1, 2, 3, 22, 27, 53, 54], kingdom: KINGDOM.SETDATA };

    export const DIMENSION_DEPARTMENT = {id: 53, key: '部署', domain: DOMAIN.TARGET,  reject: [1, 2, 3, 21, 22, 27, 54], kingdom: KINGDOM.SETDATA };
    export const TARGET_DEPARTMENT_MULTI = {id: 54, key: '複数部署', domain: DOMAIN.TARGET, reject: [1, 2, 3, 18, 21, 22, 27, 53], kingdom: KINGDOM.SETDATA};

    export const COMPARE_TARGET_DEPARTMENT = {id: MaterialId.COMPARE_TARGET_DEPARTMENT, key: '部署', domain: DOMAIN.COMPARE_TARGET,  reject: [29, 30, 31, 32], kingdom: KINGDOM.SETDATA };

    // export const COMPARE_TARGET_DEPARTMENT = {id: 30, key: 'グループ', domain: DOMAIN.COMPARE_TARGET,  reject: [29, 30, 31, 32], kingdom: KINGDOM.SETDATA };
  }

  export const MATERIALS_BETA = [
    MATERIAL_BETA.TARGET_MEMBER,
    MATERIAL.TARGET_ALL,
    MATERIAL_BETA.DIMENSION_GROUP,
    MATERIAL.TARGET_GROUP_MULTI,
    // MATERIAL.TARGET_YEAR,
    // MATERIAL.TARGET_MONTH,
    // MATERIAL.TARGET_DATE,
    MATERIAL.MEASURE_LOGING_TIME,
    MATERIAL_BETA.MEASURE_WORKING_TIME,
    MATERIAL.MEASURE_OVER_TIME,
    // MATERIAL.MEASURE_SETTING_TIME,
    // MATERIAL.DIMENSION_MEMBER,
    MATERIAL_BETA.DIMENSION_YEAR,
    MATERIAL_BETA.DIMENSION_MONTH,
    MATERIAL_BETA.DIMENSION_DATE,
    MATERIAL_BETA.DIMENSION_HOUR,
    MATERIAL.MEASURE_UNACHIEVED_TIME,
    MATERIAL.MEASURE_INTERVAL_TIME,
    MATERIAL.MEASURE_APP,
    MATERIAL.MEASURE_COUNT,
    MATERIAL.TYPE_SUM,
    MATERIAL.TYPE_AVERAGE,
    // MATERIAL.TYPE_COMPARE_SUM,
    // MATERIAL.TYPE_COMPARE_AVERAGE,
    MATERIAL.COMPARE_TYPE_SUM,
    MATERIAL.COMPARE_TYPE_AVERAGE,
    MATERIAL.COMPARE_TARGET_MEMBER,
    MATERIAL.COMPARE_TARGET_GROUP,
    MATERIAL_BETA.COMPARE_TARGET_DEPARTMENT,
    MATERIAL.COMPARE_TARGET_COMPANY,
    // MATERIAL.COMPARE_TARGET_ALL,
    MATERIAL.COMPARE_MEASURE_LOGING_TIME,
    MATERIAL.COMPARE_MEASURE_WORKING_TIME,
    MATERIAL.COMPARE_MEASURE_OVER_TIME,
    MATERIAL.COMPARE_MEASURE_UNACHIEVED_TIME,
    MATERIAL.COMPARE_MEASURE_INTERVAL_TIME,
    MATERIAL.COMPARE_MEASURE_APP,
    MATERIAL.COMPARE_MEASURE_COUNT,

    MATERIAL_BETA.DIMENSION_DEPARTMENT,
    MATERIAL_BETA.TARGET_DEPARTMENT_MULTI,
    // MATERIAL_BETA.COMPARE_TARGET_DEPARTMENT,
  ] as IMaterial[];

  export const getTargetSetData = (x: IMaterial[]) => x.find((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.TARGET && v.kingdom === NOC.MATERIAL.V3.KINGDOM.SETDATA));
  export const getCompareTargetSetData = (x: IMaterial[]) => x.find((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_TARGET && v.kingdom === NOC.MATERIAL.V3.KINGDOM.SETDATA));
  export const getTargetDate = (x: IMaterial[]) => x.find((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.TARGET && v.kingdom === NOC.MATERIAL.V3.KINGDOM.DATE));
  export const getTargets = (x: IMaterial[]) => x.filter((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.TARGET));
  export const getCompareTargets = (x: IMaterial[]) => x.filter((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_TARGET));
  export const getMeasures = (x: IMaterial[]) => x.filter((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.MEASURE));
  export const getCompareMeasures = (x: IMaterial[]) => x.filter((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_MEASURE));
  export const getDimension = (x: IMaterial[]) => x.find((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.DIMENSION));
  export const getDimensions = (x: IMaterial[]) => x.filter((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.DIMENSION));
  export const getType = (x: IMaterial[]) => x.find((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.TYPE));
  export const getCompareType = (x: IMaterial[]) => x.find((v) => (v.domain === NOC.MATERIAL.V3.DOMAIN.COMPARE_TYPE));
}


export namespace NOC.SETTING.MODE {
  export const NEW = 'new';
  export const NEW_NEXT = 'new_next';
  export const NEW_DEPARTMENT = 'new_department';
  export const NEW_DEPARTMENT_NEXT = 'new_department_next';
  export const EDIT = 'edit';
  export const EDIT_BASE = 'edit_base';
  export const EDIT_PROFILE = 'edit_profile';
  export const SELECT = 'select';
  export const NORMAL = '';
  export const NORMAL_DEPARTMENT = 'normal_department';
  export const EDIT_BASE_DEPARTMENT = 'edit_base_department';
  export const CSV_IMPORT = 'csv_import';
  export const CHARGE = 'charge';

  export const APPLICATION = 'application';
  export const NOT_APPLICATION = '';
  export const CONFIRMATION_BANKS = 'confirmation-banks';
  export const CONFIRMATION_CREDIT = 'confirmation-credit';
  export const CONTRACTED_BANKS = 'contracted-banks';
  export const CONTRACTED_CREDIT = 'contracted-credit';
  export const PAYMENT_EDIT_BANKS = 'payment-edit-banks';
  export const PAYMENT_EDIT_CREDIT = 'payment-edit-credit';
  export const CANCEL_CONSTRACTED = 'cancel-constracted';
}


export namespace NOC.CONTACT {
  export const INTRODUCTION = '導入方法について';
  export const OPERATION = '操作方法の不明な点について';
  export const PAY = '請求・料金について';
  export const CANCELLATION = '解約について';
  export const REQUEST = 'コンテンツリクエスト';
  export const OPINION = 'サービスについてのご意見・ご要望';
  export const OTHERS = 'その他';
}

export namespace NOC.CONTACT.VALUE {
  export const INTRODUCTION = 1;
  export const OPERATION = 2;
  export const PAY = 3;
  export const OPINION = 4;
  export const CANCELLATION = 5;
  export const REQUEST = 6;
  export const OTHERS = 99;
  export const returnStrCategory = ((value: number) => {
    let returnValue = '';
    switch (value) {
      case INTRODUCTION:
        returnValue = NOC.CONTACT.INTRODUCTION;
        break;
      case OPERATION:
        returnValue = NOC.CONTACT.OPERATION;
        break;
      case PAY:
        returnValue = NOC.CONTACT.PAY;
        break;
      case OPINION:
        returnValue = NOC.CONTACT.OPINION;
        break;
      case CANCELLATION:
        returnValue = NOC.CONTACT.CANCELLATION;
        break;
      case REQUEST:
        returnValue = NOC.CONTACT.REQUEST;
        break;
      case OTHERS:
        returnValue = NOC.CONTACT.OTHERS;
        break;
    }
    return returnValue;
  });
}

export namespace NOC.API {
  export const SINGUP = 'auth/signup';
  export const LOGIN = 'auth/login';
  export const LOGOUT = 'auth/logout';
  export const CHECK = 'auth/check';
  export const CONFIRM = 'auth/confirm';
}

export namespace NOC.HOLIDAY {
  export const JAPAN2020 = [
    '2020-01-01', '2020-01-13',
    '2020-02-11', '2020-02-23', '2020-02-24',
    '2020-03-20',
    '2020-04-29',
    '2020-05-03', '2020-05-04', '2020-05-05', '2020-05-06',
    '2020-07-23', '2020-07-24',
    '2020-08-10',
    '2020-09-21', '2020-09-22',
    '2020-11-03', '2020-11-23',
  ];
  export const JAPAN2021 = [
    '2021-01-01', '2021-01-11',
    '2021-02-11', '2021-02-23',
    '2021-03-20',
    '2021-04-29',
    '2021-05-03', '2021-05-04', '2021-05-05',
    '2021-07-19',
    '2021-08-11',
    '2021-09-20', '2021-09-23',
    '2021-10-11', '2021-11-03', '2021-11-23',
  ];
}

export namespace NOC.GRAPH.OPTIONS {
  export const BCOLOR = ['#688BE3', '#8660E3', '#EAB25A', '#6AC58E', '#E38A84'];
  export const BCOLOR_BETA = ['#3368EE', '#73BA00', '#FFA800', '#F14665', '#8D46E8', '#64AAFB', '#BAC635', '#39C0C7', '#FF9381', '#EDD501', '#969AA6'];
  export const BCOLOR_BLUE_ONLY = ['#3368EE', '#002789', '#5C94FF', '#84B5FF', '#0D42C7', '#39B8FF', '#9BDBFF', '#0074B5', '#78CFFF', '#0097EB'];
  export const BCOLOR_GREEN_ONLY = ['#73BA00', '#265700', '#5F9A00', '#AFD275', '#4A7700', '#00B071', '#9DDEC7', '#005737', '#5BD0A6', '#008354'];
  export const BCOLOR_RED_ONLY = ['#F14665', '#C60023', '#FF9BAD', '#FFC2CD', '#E4153A', '#FF3F25', '#FFA38F', '#B01500', '#FF7759', '#E31B00'];
  export const YEAR = ['2020', '2021', '2022', '2023', '2024', '2025'];

  // @todo: iwasaki REMOLABO-1121 色の組み合わせによって見づらいため、仮の色変更(2色目まで) 3番目以降は要調整
  export const BCOLOR_BLUE_BASE = ['#3368EE', '#BAC635', '#64AAFB', '#39C0C7', '#8D46E8', '#969AA6', '#F14665', '#FFA800', '#FF9381', '#73BA00', '#EDD501'];
  export const BCOLOR_GREEN_BASE = ['#73BA00', '#FFA800', '#EDD501', '#39C0C7', '#969AA6', '#F14665', '#64AAFB', '#FF9381', '#8D46E8', '#3368EE', '#BAC635'];
  export const BCOLOR_RED_BASE = ['#F14665', '#64AAFB', '#FFA800', '#FF9381', '#8D46E8', '#969AA6', '#3368EE', '#BAC635', '#39C0C7', '#73BA00', '#EDD501'];

  // export const BCOLOR_BLUE_BASE = ['#005AFF', '#4DC4FF', '#03AF7A'];
  // export const BCOLOR_GREEN_BASE = ['#03AF7A', '#b7da3f', '#FFF100'];
  // export const BCOLOR_RED_BASE = ['#FF4B00', '#F6AA00', '#990099'];
}

/*
export namespace NOC.DASHBOARD.VIEW {
  export const DEFAULT  = [
    {
      name: 'ダッシュボード1',
      layout: [
        {x: 0, y: 0, w: 1, h: 1, i: 0, default: true, name: 'SampleGadget', gadgetID: 2, resized: true, moved: false},
        {x: 2, y: 0, w: 1, h: 1, i: 1, default: true, name: 'SampleGadget', gadgetID: 3, resized: true, moved: false},
        {x: 0, y: 1, w: 1, h: 1, i: 2, default: true, name: 'SampleGadget', gadgetID: 4, resized: true, moved: false},
        {x: 1, y: 1, w: 2, h: 1, i: 3, default: true, name: 'SampleGadget', gadgetID: 5, resized: true, moved: false},
        {x: 1, y: 0, w: 1, h: 1, i: 4, default: true, name: 'SampleGadget', gadgetID: 6, resized: true, moved: false},
      ],
    },
  ];
}
*/

import {IGadget} from '../../models/typed/gadget';
import {IFreeboard} from '../../models/views/dashboard';
import * as moment from '../moment';
export namespace NOC.GADGET.DEFAULT {
  const COMMENT = {
    CSV: 'ログの閲覧・ダウンロード',
    SAMPLE1: '全メンバーの実労働時間を日毎に示したグラフ',
    SAMPLE2: 'メンバー毎の実労働時間を時間毎に示したグラフ',
    SAMPLE3: '全メンバーの実労働時間、残業時間、就業未達成時間を日毎に示したリスト',
    SAMPLE4: 'メンバー毎の実労働時間を月毎に示したグラフ',
    SAMPLE5: '全メンバーの残業時間を月毎に示したグラフ',
    SAMPLE6: '全メンバーの実労働時間、残業時間、就業未達成時間を月毎に示したリスト',
    SAMPLE7: 'メンバー毎の実労働時間を日毎に示したグラフ',
    SAMPLE8: 'メンバー毎のアプリ使用時間を時間毎に示したグラフ',
    SAMPLE9: '実労働時間毎のメンバー数を月毎に示したグラフ',
    SAMPLE10: 'メンバーの操作回数を時間毎に示したグラフ',
    SAMPLE11: 'メンバー毎の開始時間、終了時間、実労働時間を月毎に示したリスト',
    SAMPLE12: 'メンバーの操作回数を時間毎に示したグラフ',
    SAMPLE13: 'メンバー毎の実労働時間、残業時間を月毎に示したリスト',
    // SAMPLE14: 'メンバー毎の勤務時間を時間毎に示したグラフ',
    // SAMPLE15: '全メンバーの勤務時間、残業時間、就業未達成時間を日毎に示したリスト',
    // SAMPLE16: '全メンバーの残業時間を月毎に示したグラフ',
    // SAMPLE17: '全メンバーの勤務時間、残業時間、就業未達成時間を月毎に示したリスト',
    // SAMPLE18: '勤務時間毎のメンバー数を月毎に示したグラフ',
    SAMPLE19: 'メンバーの操作回数を日毎に示したグラフ',

    // SAMPLE20: 'メンバー毎の勤務時間を日毎に示したグラフ',
    SAMPLE21: '部署毎の就業時間を月毎に示したグラフ',
    SAMPLE22: '部署毎の就業時間を日毎に示したグラフ',
    SAMPLE23: '部署毎の実労働時間を月毎に示したグラフ',
    SAMPLE24: '部署毎の実労働時間を日毎に示したグラフ',
    SAMPLE25: 'メンバーと所属部署毎の就業時間を月毎に示したグラフ',
    SAMPLE26: 'メンバーと所属部署毎の就業時間を日毎に示したグラフ',
    SAMPLE27: 'メンバーと所属部署毎の就業時間を時間毎に示したグラフ',
    SAMPLE28: 'メンバーと所属部署毎の実労働時間を月毎に示したグラフ',
    SAMPLE29: 'メンバーと所属部署毎の実労働時間を日毎に示したグラフ',
    SAMPLE30: 'メンバーと所属部署毎の実労働時間を時間毎に示したグラフ',

    SAMPLE50: '所定労働時間外、法定労働時間外、超過回数を月毎と年毎に示したリスト',
    SAMPLE51: '部署、氏名、職種、違反内容を示したリスト',
    SAMPLE52: '部署毎の禁止アプリ利用者を月毎に示したリスト',
    SAMPLE53: '部署毎の禁止アプリ利用時間を月毎に示したグラフ',
    SAMPLE54: '部署毎の禁止アプリ利用時間を日毎に示したグラフ',
    SAMPLE55: 'メンバーと所属部署毎の禁止アプリ利用時間を月毎に示したグラフ',
    SAMPLE56: 'メンバーと所属部署毎の禁止アプリ利用時間を日毎に示したグラフ',
    SAMPLE57: 'メンバーと所属部署毎の禁止アプリ利用時間を時間毎に示したグラフ',
    SAMPLE58: 'メンバーの各アプリ利用時間を月毎に示したグラフ',
    SAMPLE59: 'メンバーの各アプリ利用時間を日毎に示したグラフ',

    SAMPLE60: 'ユーザーごとの就業時間の推移を月毎に示したグラフ',
    SAMPLE61: 'ユーザーごとの就業時間の推移を日毎に示したグラフ',
    SAMPLE62: 'ユーザーごとの実労働時間の推移を月毎に示したグラフ',
    SAMPLE63: 'ユーザーごとの実労働時間の推移を日毎に示したグラフ',
    SAMPLE64: 'ユーザーごとの禁止アプリ利用時間の推移を月毎に示したグラフ',
    SAMPLE65: 'ユーザーごとの禁止アプリ利用時間の推移を日毎に示したグラフ',
    SAMPLE67: 'メンバーの各アプリ利用時間を月毎に示したグラフ',
  };
  const GADGET_TYPE = {
    DL: 'CSVDLGadget',
    SAMPLE: 'SampleGadget',
    SAMPLEV3: 'SampleGadgetV3',
  };
  export const BOARD_TYPE = {
    FREE: 0,
    USER: 1,
    DEPARTMENT: 2,
    GROUP: 3,
  };
  // デフォルトダッシュボード：フリーボード
  export const VIEW = [
    {
      name: 'タブ1',
      layout: [
        // {x: 0, y: 0, w: 1, h: 1, i: 0, default: true, name: 'SampleGadget', gadgetID: 2, resized: true, moved: false},
        // {x: 1, y: 0, w: 1, h: 1, i: 4, default: true, name: 'SampleGadget', gadgetID: 3, resized: true, moved: false},
        // {x: 2, y: 0, w: 1, h: 1, i: 1, default: true, name: 'SampleGadget', gadgetID: 4, resized: true, moved: false},
        // {x: 0, y: 1, w: 1, h: 1, i: 2, default: true, name: 'SampleGadget', gadgetID: 5, resized: true, moved: false},
        // {x: 1, y: 1, w: 1, h: 1, i: 3, default: true, name: 'SampleGadget', gadgetID: 6, resized: true, moved: false},
        // {x: 2, y: 1, w: 1, h: 1, i: 5, default: true, name: 'SampleGadget', gadgetID: 7, resized: true, moved: false},
        // {x: 3, y: 0, w: 1, h: 1, i: 6, default: true, name: 'SampleGadgetV3', gadgetID: 9, resized: true, moved: false},
        // {x: 3, y: 1, w: 1, h: 1, i: 7, default: true, name: 'SampleGadgetV3', gadgetID: 10, resized: true, moved: false},
        // {x: 0, y: 2, w: 1, h: 1, i: 8, default: true, name: 'SampleGadgetV3', gadgetID: 11, resized: true, moved: false},

        {x: 0, y: 0, w: 1, h: 1, i: 0, default: true, name: 'CSVDLGadget', gadgetID: 1, resized: true, moved: false},
        {x: 1, y: 0, w: 1, h: 1, i: 4, default: true, name: 'SampleGadget', gadgetID: 2, resized: true, moved: false},
        {x: 2, y: 0, w: 1, h: 1, i: 1, default: true, name: 'SampleGadget', gadgetID: 3, resized: true, moved: false},
        {x: 0, y: 1, w: 1, h: 1, i: 2, default: true, name: 'SampleGadget', gadgetID: 4, resized: true, moved: false},
        {x: 1, y: 1, w: 1, h: 1, i: 3, default: true, name: 'SampleGadget', gadgetID: 5, resized: true, moved: false},
        {x: 2, y: 1, w: 1, h: 1, i: 5, default: true, name: 'SampleGadget', gadgetID: 6, resized: true, moved: false},
        {x: 0, y: 2, w: 1, h: 1, i: 6, default: true, name: 'SampleGadget', gadgetID: 7, resized: true, moved: false},
        {x: 1, y: 2, w: 1, h: 1, i: 7, default: true, name: 'SampleGadget', gadgetID: 8, resized: true, moved: false},
        {x: 2, y: 2, w: 1, h: 1, i: 8, default: true, name: 'SampleGadgetV3', gadgetID: 9, resized: true, moved: false},
        {x: 0, y: 3, w: 1, h: 1, i: 9, default: true, name: 'SampleGadgetV3', gadgetID: 10, resized: true, moved: false},
        {x: 1, y: 3, w: 1, h: 1, i: 10, default: true, name: 'SampleGadgetV3', gadgetID: 11, resized: true, moved: false},
      ],
      id: 0,
      boardType: 0,
      boardID: 0,
    },
  ];
  // デフォルトダッシュボード：個人
  export const VIEW_USER = [
    {
      name: '標準グラフ',
      layout: [
        // {x: 0, y: 0, w: 1, h: 1, i: 102, default: true, name: 'SampleGadget', gadgetID: 3, resized: true, moved: false},
        // {x: 1, y: 0, w: 1, h: 1, i: 103, default: true, name: 'CSVDLGadget', gadgetID: 1, resized: true, moved: false},
        // {x: 2, y: 0, w: 1, h: 1, i: 104, default: true, name: 'SampleGadget', gadgetID: 9, resized: true, moved: false},
        // {x: 0, y: 1, w: 1, h: 1, i: 105, default: true, name: 'SampleGadgetV3', gadgetID: 13, resized: true, moved: false},
        // {x: 1, y: 1, w: 1, h: 1, i: 106, default: true, name: 'SampleGadgetV3', gadgetID: 15, resized: true, moved: false},
        // {x: 2, y: 1, w: 2, h: 1, i: 107, default: true, name: 'SampleGadgetV3', gadgetID: 12, resized: true, moved: false},
        // {x: 0, y: 2, w: 1, h: 1, i: 108, default: true, name: 'SampleGadgetV3', gadgetID: 14, resized: true, moved: false},


        {x: 0, y: 0, w: 1, h: 1, i: 102, default: true, name: 'CSVDLGadget', gadgetID: 1, resized: true, moved: false},
        {x: 1, y: 0, w: 1, h: 1, i: 103, default: true, name: 'SampleGadget', gadgetID: 3, resized: true, moved: false},
        {x: 2, y: 1, w: 1, h: 1, i: 107, default: true, name: 'SampleGadgetV3', gadgetID: 13, resized: true, moved: false},
        {x: 0, y: 1, w: 1, h: 1, i: 105, default: true, name: 'SampleGadgetV3', gadgetID: 9, resized: true, moved: false},
        // {x: 1, y: 1, w: 1, h: 1, i: 106, default: true, name: 'SampleGadgetV3', gadgetID: 12, resized: true, moved: false},
        {x: 2, y: 0, w: 1, h: 1, i: 104, default: true, name: 'SampleGadget', gadgetID: 8, resized: true, moved: false},
        // {x: 1, y: 2, w: 1, h: 1, i: 109, default: true, name: 'SampleGadget', gadgetID: 26, resized: true, moved: false},
        // {x: 0, y: 3, w: 1, h: 1, i: 111, default: true, name: 'SampleGadget', gadgetID: 28, resized: true, moved: false},
        // {x: 1, y: 3, w: 1, h: 1, i: 112, default: true, name: 'SampleGadget', gadgetID: 29, resized: true, moved: false},
        {x: 1, y: 4, w: 1, h: 1, i: 115, default: true, name: 'SampleGadgetV3', gadgetID: 51, resized: true, moved: false},
        {x: 0, y: 6, w: 1, h: 1, i: 120, default: true, name: 'SampleGadgetV3', gadgetID: 67, resized: true, moved: false},
        {x: 0, y: 2, w: 1, h: 1, i: 108, default: true, name: 'SampleGadgetV3', gadgetID: 14, resized: true, moved: false},
        {x: 2, y: 2, w: 1, h: 1, i: 110, default: true, name: 'SampleGadget', gadgetID: 27, resized: true, moved: false},
        {x: 2, y: 3, w: 1, h: 1, i: 113, default: true, name: 'SampleGadget', gadgetID: 30, resized: true, moved: false},
        // {x: 0, y: 4, w: 1, h: 1, i: 114, default: true, name: 'SampleGadget', gadgetID: 31, resized: true, moved: false},
        // {x: 2, y: 4, w: 1, h: 1, i: 116, default: true, name: 'SampleGadgetV3', gadgetID: 56, resized: true, moved: false},
        {x: 0, y: 5, w: 1, h: 1, i: 117, default: true, name: 'SampleGadgetV3', gadgetID: 57, resized: true, moved: false},
        // {x: 1, y: 5, w: 1, h: 1, i: 118, default: true, name: 'SampleGadgetV3', gadgetID: 58, resized: true, moved: false},
        // {x: 2, y: 5, w: 1, h: 1, i: 119, default: true, name: 'SampleGadgetV3', gadgetID: 59, resized: true, moved: false},

      ],
      id: 0,
      boardType: 1,
      boardID: 0,
    },
  ];
  // デフォルトダッシュボード：部署
  export const VIEW_DEPARTMENT = [
    {
      name: '標準グラフ',
      layout: [
        // {x: 0, y: 0, w: 1, h: 1, i: 203, default: true, name: 'SampleGadget', gadgetID: 21, resized: true, moved: false},
        // {x: 1, y: 0, w: 1, h: 1, i: 204, default: true, name: 'SampleGadgetV3', gadgetID: 16, resized: true, moved: false},
        // {x: 2, y: 0, w: 1, h: 1, i: 205, default: true, name: 'SampleGadgetV3', gadgetID: 17, resized: true, moved: false},
        // {x: 0, y: 1, w: 1, h: 1, i: 206, default: true, name: 'SampleGadgetV3', gadgetID: 18, resized: true, moved: false},
        // {x: 1, y: 1, w: 1, h: 1, i: 207, default: true, name: 'SampleGadgetV3', gadgetID: 19, resized: true, moved: false},
        // {x: 2, y: 1, w: 1, h: 1, i: 208, default: true, name: 'SampleGadgetV3', gadgetID: 20, resized: true, moved: false},

        // {x: 3, y: 1, w: 1, h: 1, i: 209, default: true, name: 'SampleGadgetV3', gadgetID: 54, resized: true, moved: false},


        // {x: 0, y: 0, w: 1, h: 1, i: 203, default: true, name: 'SampleGadget', gadgetID: 2, resized: true, moved: false},
        {x: 1, y: 0, w: 1, h: 1, i: 204, default: true, name: 'SampleGadget', gadgetID: 4, resized: true, moved: false},
        // {x: 2, y: 0, w: 1, h: 1, i: 205, default: true, name: 'SampleGadget', gadgetID: 6, resized: true, moved: false},
        {x: 0, y: 1, w: 1, h: 1, i: 206, default: true, name: 'SampleGadget', gadgetID: 7, resized: true, moved: false},
        {x: 1, y: 1, w: 1, h: 1, i: 207, default: true, name: 'SampleGadgetV3', gadgetID: 10, resized: true, moved: false},
        {x: 2, y: 1, w: 1, h: 1, i: 208, default: true, name: 'SampleGadgetV3', gadgetID: 11, resized: true, moved: false},
        {x: 0, y: 2, w: 1, h: 1, i: 209, default: true, name: 'SampleGadget', gadgetID: 22, resized: true, moved: false},
        {x: 1, y: 2, w: 1, h: 1, i: 210, default: true, name: 'SampleGadget', gadgetID: 23, resized: true, moved: false},
        {x: 2, y: 2, w: 1, h: 1, i: 211, default: true, name: 'SampleGadget', gadgetID: 24, resized: true, moved: false},
        {x: 0, y: 3, w: 1, h: 1, i: 212, default: true, name: 'SampleGadget', gadgetID: 25, resized: true, moved: false},
        {x: 2, y: 4, w: 1, h: 1, i: 217, default: true, name: 'SampleGadgetV3', gadgetID: 52, resized: true, moved: false},
        {x: 0, y: 5, w: 1, h: 1, i: 218, default: true, name: 'SampleGadgetV3', gadgetID: 53, resized: true, moved: false},
        // {x: 1, y: 5, w: 1, h: 1, i: 219, default: true, name: 'SampleGadgetV3', gadgetID: 54, resized: true, moved: false},
        {x: 2, y: 5, w: 1, h: 1, i: 220, default: true, name: 'SampleGadgetV3', gadgetID: 55, resized: true, moved: false},
      ],
      id: 0,
      boardType: 2,
      boardID: 0,
    },
  ];
  // デフォルトダッシュボード：グループ
  export const VIEW_GROUP = [
    {
      name: '標準グラフ',
      layout: [
        // {x: 0, y: 0, w: 1, h: 1, i: 300, default: true, name: 'SampleGadgetV3', gadgetID: 6, resized: true, moved: false},
        // {x: 1, y: 0, w: 1, h: 1, i: 301, default: true, name: 'SampleGadgetV3', gadgetID: 7, resized: true, moved: false},
        // {x: 2, y: 0, w: 1, h: 1, i: 302, default: true, name: 'SampleGadgetV3', gadgetID: 8, resized: true, moved: false},
        // {x: 3, y: 0, w: 1, h: 1, i: 303, default: true, name: 'SampleGadgetV3', gadgetID: 9, resized: true, moved: false},

        // {x: 0, y: 1, w: 1, h: 1, i: 304, default: true, name: 'SampleGadgetV3', gadgetID: 16, resized: true, moved: false},
        // {x: 1, y: 1, w: 1, h: 1, i: 305, default: true, name: 'SampleGadgetV3', gadgetID: 17, resized: true, moved: false},
        // {x: 2, y: 1, w: 1, h: 1, i: 306, default: true, name: 'SampleGadgetV3', gadgetID: 18, resized: true, moved: false},

        {x: 0, y: 0, w: 1, h: 1, i: 305, default: true, name: 'SampleGadgetV3', gadgetID: 61, resized: true, moved: false},
        {x: 1, y: 0, w: 1, h: 1, i: 306, default: true, name: 'SampleGadgetV3', gadgetID: 62, resized: true, moved: false},
        {x: 0, y: 1, w: 1, h: 1, i: 307, default: true, name: 'SampleGadgetV3', gadgetID: 63, resized: true, moved: false},
        {x: 1, y: 1, w: 1, h: 1, i: 308, default: true, name: 'SampleGadgetV3', gadgetID: 64, resized: true, moved: false},
        {x: 2, y: 1, w: 1, h: 1, i: 309, default: true, name: 'SampleGadgetV3', gadgetID: 65, resized: true, moved: false},
        {x: 0, y: 2, w: 1, h: 1, i: 310, default: true, name: 'SampleGadgetV3', gadgetID: 66, resized: true, moved: false},
        {x: 2, y: 2, w: 1, h: 1, i: 300, default: true, name: 'SampleGadget', gadgetID: 4, resized: true, moved: false},
        {x: 0, y: 3, w: 1, h: 1, i: 301, default: true, name: 'SampleGadget', gadgetID: 6, resized: true, moved: false},
        {x: 1, y: 3, w: 1, h: 1, i: 302, default: true, name: 'SampleGadget', gadgetID: 7, resized: true, moved: false},
        {x: 2, y: 3, w: 1, h: 1, i: 303, default: true, name: 'SampleGadget', gadgetID: 8, resized: true, moved: false},
        {x: 0, y: 4, w: 1, h: 1, i: 304, default: true, name: 'SampleGadgetV3', gadgetID: 9, resized: true, moved: false},
      ],
      id: 0,
      boardType: 3,
      boardID: 0,
    },
  ];
  // デフォルトガジェット
  export const GADGETS  = [
    {gadgetID: 1, title: 'CSVダウンロード', comment: COMMENT.CSV, gadget: GADGET_TYPE.DL, default: true, data: {values: {date: moment.fncGetYesterDay(), setData: ''} }},
    {gadgetID: 2, title: '【日次】実労働時間グラフ(全メンバー)', comment: COMMENT.SAMPLE1, gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.HORIZONTALBAR}], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.TARGET_DATE, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER], values: {setData: '', date: moment.fncGetYesterDay()}}},
    {gadgetID: 3, title: '【日次】実労働時間グラフ(メンバー毎)', comment: COMMENT.SAMPLE2, gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LINE}], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_DATE, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.DIMENSION_HOUR], values: {setData: 0, date: moment.fncGetYesterDay()}}},
    {gadgetID: 4, title: '【日次】実労働時間リスト(全メンバー)', comment: COMMENT.SAMPLE3, gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LIST}], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.TARGET_DATE, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME, NOC.MATERIAL.V3.MATERIAL.MEASURE_UNACHIEVED_TIME, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER], values: {setData: '', date: moment.fncGetYesterDay()}}},
    {gadgetID: 5, title: '【年次】総実労働時間グラフ(メンバー毎)', comment: COMMENT.SAMPLE4, gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.BAR}], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MONTH], values: {setData: 0, date: moment.fncGetThisYear()}}},
    {gadgetID: 6, title: '【月次】残業割合グラフ(全メンバー)', comment: COMMENT.SAMPLE5, gadget: GADGET_TYPE.SAMPLE, default: true,  options: {color: true}, data: {now: {}, graph: [{key: NOC.CHARTS.DOUGHNUT}], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH, NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER], values: {setData: '', date: moment.fncGetMonthStr()}}},
    {gadgetID: 7, title: '【月次】実労働時間リスト(全メンバー)', comment: COMMENT.SAMPLE6, gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LIST}], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME, NOC.MATERIAL.V3.MATERIAL.MEASURE_UNACHIEVED_TIME, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER], values: {setData: '', date: moment.fncGetMonthStr()}}},
    {gadgetID: 8, title: '【月次】実労働時間グラフ(メンバー毎)', comment: COMMENT.SAMPLE7, gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.BAR}], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE], values: {setData: '', date: moment.fncGetMonthStr()}}},
    {gadgetID: 9, title: '【日次】アプリ使用時間グラフ(メンバー毎)', comment: COMMENT.SAMPLE8, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.STACKED_BAR}], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_DATE, NOC.MATERIAL.V3.MATERIAL.MEASURE_APP, NOC.MATERIAL.V3.MATERIAL.DIMENSION_HOUR], values: {setData: '', date: moment.fncGetYesterDay()}}, options: {legend: true}},
    {gadgetID: 10, title: '【月次】人数グラフ(実労働時間毎)', comment: COMMENT.SAMPLE9, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.DOUGHNUT}], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER], values: {setData: 'all', date: moment.fncGetMonthStr()}}, options: {legend: true, multiDoughnut: true}},
    {gadgetID: 11, title: '【日次】操作回数グラフ(全メンバー)', comment: COMMENT.SAMPLE19, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LINE}], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH, NOC.MATERIAL.V3.MATERIAL.MEASURE_COUNT, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER], values: {setData: 'all', date: moment.fncGetMonthStr()}}, options: {legend: true, dataSeries: true}},
    {gadgetID: 12, title: '【月次】実労働時間リスト（メンバー毎）', comment: COMMENT.SAMPLE11, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LIST}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_LOGING_TIME, NOC.MATERIAL.V3.MATERIAL_BETA.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH], values: {setData: '', date: moment.fncGetYesterDay()}}},
    {gadgetID: 13, title: '【日次】操作回数グラフ（メンバー毎）', comment: COMMENT.SAMPLE12, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LINE}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_COUNT, NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.DIMENSION_HOUR, NOC.MATERIAL.V3.MATERIAL.TARGET_DATE], values: {setData: '', date: moment.fncGetYesterDay()}}, options: {legend: true, dataSeries: true}},
    {gadgetID: 14, title: '【年次】残業時間リスト（メンバー毎）', comment: COMMENT.SAMPLE13, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LIST}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL_BETA.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME, NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MONTH, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR], values: {setData: '', date: moment.fncGetThisYear()}}},

    // {gadgetID: 15, title: '【日次】勤務時間グラフ（メンバー毎）', comment: COMMENT.SAMPLE14, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.BAR}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH], values: {setData: 0, date: moment.fncGetYesterDay()}}},
    // {gadgetID: 16, title: '【日次】勤務時間リスト（全メンバー）', comment: COMMENT.SAMPLE15, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LIST}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME, NOC.MATERIAL.V3.MATERIAL.MEASURE_UNACHIEVED_TIME, NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_DATE], values: {setData: '', date: moment.fncGetYesterDay()}}, options: {minValue: true, legend: true}},
    // {gadgetID: 17, title: '【月次】残業割合グラフ（全メンバー）', comment: COMMENT.SAMPLE16, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.DOUGHNUT}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME, NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH], values: {setData: '', date: moment.fncGetMonthStr()}}, options: {minValue: true, legend: true,  multiDoughnut: true, color: false}},
    // {gadgetID: 18, title: '【月次】勤務時間リスト（全メンバー）', comment: COMMENT.SAMPLE17, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LIST}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_LOGING_TIME, NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME, NOC.MATERIAL.V3.MATERIAL.MEASURE_UNACHIEVED_TIME, NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH], values: {setData: '', date: moment.fncGetYesterDay()}}, options: {minValue: true, legend: true}},
    // {gadgetID: 19, title: '【月次】人数グラフ（勤務時間毎）', comment: COMMENT.SAMPLE18, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.DOUGHNUT}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_LOGING_TIME, NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH], values: {setData: '', date: moment.fncGetMonthStr()}}, options: {minValue: true, legend: true, multiDoughnut: true, color: false}},
    // {gadgetID: 20, title: '【日次】操作回数グラフ（全メンバー）', comment: COMMENT.SAMPLE19, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LINE}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_COUNT, NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH], values: {setData: '', date: moment.fncGetMonthStr()}}, options: {legend: true, dataSeries: true, minValue: true}},
    // {gadgetID: 21, title: '【日次】勤務時間グラフ（メンバー毎）', comment: COMMENT.SAMPLE20, gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.HORIZONTALBAR}], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_DATE, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER], values: {setData: '', date: moment.fncGetYesterDay()}}},

    {gadgetID: 22, title: '部署ごとの平均就業時間の推移（年間）', comment: COMMENT.SAMPLE21, gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LINE}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_AVERAGE, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR, NOC.MATERIAL.V3.MATERIAL.MEASURE_LOGING_TIME, NOC.MATERIAL.V3.MATERIAL_BETA.TARGET_DEPARTMENT_MULTI, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR], values: {setData: '', date: moment.fncGetThisYear()}}, options: {legend: true, dataSeries: true, minValue: true}},
    {gadgetID: 23, title: '部署ごとの平均就業時間の推移（月間）', comment: COMMENT.SAMPLE22, gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LINE}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_AVERAGE, NOC.MATERIAL.V3.MATERIAL.MEASURE_LOGING_TIME, NOC.MATERIAL.V3.MATERIAL_BETA.TARGET_DEPARTMENT_MULTI, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH], values: {setData: '', date: moment.fncGetMonthStr()}}, options: {legend: true, dataSeries: true, minValue: true}},

    {gadgetID: 24, title: '部署ごとの平均実労働時間の推移（年間）', comment: COMMENT.SAMPLE23, gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LINE}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_AVERAGE, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL_BETA.TARGET_DEPARTMENT_MULTI, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER], values: {setData: '', date: moment.fncGetThisYear()}}, options: {legend: true, dataSeries: true, minValue: true}},
    {gadgetID: 25, title: '部署ごとの平均実労働時間の推移（月間）', comment: COMMENT.SAMPLE24, gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LINE}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_AVERAGE, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL_BETA.TARGET_DEPARTMENT_MULTI, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER], values: {setData: '', date: moment.fncGetMonthStr()}}, options: {legend: true, dataSeries: true, minValue: true}},
    {gadgetID: 26, title: '就業時間の推移と比較（年間）', comment: COMMENT.SAMPLE25, gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.BAR}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_LOGING_TIME, NOC.MATERIAL.V3.MATERIAL_BETA.COMPARE_TARGET_DEPARTMENT, NOC.MATERIAL.V3.MATERIAL.COMPARE_TYPE_AVERAGE,  NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_LOGING_TIME, NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MONTH, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR], values: {setData: '', date: moment.fncGetThisYear()}}, options: {minValue: true, legend: true}},
    {gadgetID: 27, title: '就業時間の推移と比較（月間）', comment: COMMENT.SAMPLE26, gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.BAR}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_LOGING_TIME, NOC.MATERIAL.V3.MATERIAL_BETA.COMPARE_TARGET_DEPARTMENT, NOC.MATERIAL.V3.MATERIAL.COMPARE_TYPE_AVERAGE,  NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_LOGING_TIME, NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH], values: {setData: '', date: moment.fncGetMonthStr()}}, options: {minValue: true, legend: true}},
    {gadgetID: 28, title: '就業時間の推移と比較（日）', comment: COMMENT.SAMPLE27, gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.BAR}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_LOGING_TIME, NOC.MATERIAL.V3.MATERIAL_BETA.COMPARE_TARGET_DEPARTMENT, NOC.MATERIAL.V3.MATERIAL.COMPARE_TYPE_AVERAGE,  NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_LOGING_TIME, NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.DIMENSION_HOUR, NOC.MATERIAL.V3.MATERIAL.TARGET_DATE], values: {setData: '', date: moment.fncGetYesterDay()}}, options: {minValue: true, legend: true}},
    {gadgetID: 29, title: '実労働時間の推移と比較（年間）', comment: COMMENT.SAMPLE28, gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.BAR}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL_BETA.COMPARE_TARGET_DEPARTMENT, NOC.MATERIAL.V3.MATERIAL.COMPARE_TYPE_AVERAGE,  NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MONTH, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR], values: {setData: '', date: moment.fncGetThisYear()}}, options: {minValue: true, legend: true}},
    {gadgetID: 30, title: '実労働時間の推移と比較（月間）', comment: COMMENT.SAMPLE29, gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.BAR}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL_BETA.COMPARE_TARGET_DEPARTMENT, NOC.MATERIAL.V3.MATERIAL.COMPARE_TYPE_AVERAGE,  NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH], values: {setData: '', date: moment.fncGetMonthStr()}}, options: {minValue: true, legend: true}},
    {gadgetID: 31, title: '実労働時間の推移と比較（日）', comment: COMMENT.SAMPLE30, gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.BAR}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL_BETA.COMPARE_TARGET_DEPARTMENT, NOC.MATERIAL.V3.MATERIAL.COMPARE_TYPE_AVERAGE,  NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.DIMENSION_HOUR, NOC.MATERIAL.V3.MATERIAL.TARGET_DATE], values: {setData: '', date: moment.fncGetYesterDay()}}, options: {minValue: true, legend: true}},

    {gadgetID: 51, title: '36協定状況リスト', comment: COMMENT.SAMPLE50, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LIST}], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH, NOC.MATERIAL.V3.MATERIAL.MEASURE_36_STATUS, NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.DIMENSION_36_MONTH], values: {setData: '', date: moment.fncGetMonthStr()}}},
    {gadgetID: 52, title: '36協定違反者リスト', comment: COMMENT.SAMPLE51, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LIST}], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_DATE, NOC.MATERIAL.V3.MATERIAL.MEASURE_36_VIOLATION, NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER], values: {setData: '', date: moment.fncGetYesterDay()}}},
    {gadgetID: 53, title: '禁止アプリ利用者リスト', comment: COMMENT.SAMPLE52, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LIST}], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH, NOC.MATERIAL.V3.MATERIAL.MEASURE_BANNED_APP_LIST, NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER], values: {setData: '', date: moment.fncGetMonthStr()}}},

    {gadgetID: 54, title: '部署ごとの禁止アプリ利用時間の推移（年間）', comment: COMMENT.SAMPLE53, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LINE}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_AVERAGE, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR, NOC.MATERIAL.V3.MATERIAL.MEASURE_BANNED_APP, NOC.MATERIAL.V3.MATERIAL_BETA.TARGET_DEPARTMENT_MULTI, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER], values: {setData: '', date: moment.fncGetThisYear()}}, options: {minValue: true, legend: true, dataSeries: true}},
    {gadgetID: 55, title: '部署ごとの禁止アプリ利用時間の推移（月間）', comment: COMMENT.SAMPLE54, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LINE}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_AVERAGE, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH, NOC.MATERIAL.V3.MATERIAL.MEASURE_BANNED_APP, NOC.MATERIAL.V3.MATERIAL_BETA.TARGET_DEPARTMENT_MULTI, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER], values: {setData: '', date: moment.fncGetMonthStr()}}, options: {minValue: true, legend: true, dataSeries: true}},
    {gadgetID: 56, title: '禁止アプリ利用時間の推移と比較（年間）', comment: COMMENT.SAMPLE55, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.BAR}], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR, NOC.MATERIAL.V3.MATERIAL.MEASURE_BANNED_APP, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MONTH, NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_BANNED_APP, NOC.MATERIAL.V3.MATERIAL.COMPARE_TYPE_AVERAGE, NOC.MATERIAL.V3.MATERIAL_BETA.COMPARE_TARGET_DEPARTMENT], values: {setData: '', date: moment.fncGetThisYear()}}, options: {minValue: true, legend: true}},
    {gadgetID: 57, title: '禁止アプリ利用時間の推移と比較（月間）', comment: COMMENT.SAMPLE56, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.BAR}], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH, NOC.MATERIAL.V3.MATERIAL.MEASURE_BANNED_APP, NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE, NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_BANNED_APP, NOC.MATERIAL.V3.MATERIAL.COMPARE_TYPE_AVERAGE, NOC.MATERIAL.V3.MATERIAL_BETA.COMPARE_TARGET_DEPARTMENT], values: {setData: '', date: moment.fncGetMonthStr()}}, options: {minValue: true, legend: true}},
    {gadgetID: 58, title: '禁止アプリ利用時間の推移と比較（日）', comment: COMMENT.SAMPLE57, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.BAR}], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_DATE, NOC.MATERIAL.V3.MATERIAL.MEASURE_BANNED_APP, NOC.MATERIAL.V3.MATERIAL.DIMENSION_HOUR, NOC.MATERIAL.V3.MATERIAL.COMPARE_MEASURE_BANNED_APP, NOC.MATERIAL.V3.MATERIAL.COMPARE_TYPE_AVERAGE, NOC.MATERIAL.V3.MATERIAL_BETA.COMPARE_TARGET_DEPARTMENT], values: {setData: '', date: moment.fncGetYesterDay()}}, options: {minValue: true, legend: true}},

    {gadgetID: 59, title: '各アプリ利用時間の推移（年間)', comment: COMMENT.SAMPLE58, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.STACKED_BAR}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_APP, NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MONTH, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR], values: {setData: '', date: moment.fncGetThisYear()}}, options: {minValue: true, legend: true}},
    {gadgetID: 60, title: '各アプリ利用時間の推移（月間)', comment: COMMENT.SAMPLE59, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.STACKED_BAR}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_APP, NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH], values: {setData: '', date: moment.fncGetMonthStr()}}, options: {minValue: true, legend: true}},

    {gadgetID: 61, title: 'ユーザーごとの就業時間の推移（年間）', comment: COMMENT.SAMPLE60, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LINE}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_LOGING_TIME, NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR], values: {setData: '', date: moment.fncGetThisYear()}}, options: {legend: true, dataSeries: true}},
    {gadgetID: 62, title: 'ユーザーごとの就業時間の推移（月間）', comment: COMMENT.SAMPLE61, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LINE}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_LOGING_TIME, NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH], values: {setData: '', date: moment.fncGetMonthStr()}}, options: {legend: true, dataSeries: true}},
    {gadgetID: 63, title: 'ユーザーごとの実労働時間の推移（年間）', comment: COMMENT.SAMPLE62, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LINE}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR], values: {setData: '', date: moment.fncGetThisYear()}}, options: {legend: true, dataSeries: true}},
    {gadgetID: 64, title: 'ユーザーごとの実労働時間の推移（月間）', comment: COMMENT.SAMPLE63, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LINE}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH], values: {setData: '', date: moment.fncGetMonthStr()}}, options: {legend: true, dataSeries: true}},
    {gadgetID: 65, title: 'ユーザーごとの禁止アプリ利用時間の推移（年間）', comment: COMMENT.SAMPLE64, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LINE}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_BANNED_APP, NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR], values: {setData: '', date: moment.fncGetThisYear()}}, options: {minValue: true, legend: true, dataSeries: true}},
    {gadgetID: 66, title: 'ユーザーごとの禁止アプリ利用時間の推移（月間）', comment: COMMENT.SAMPLE65, gadget: GADGET_TYPE.SAMPLEV3, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.LINE}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_BANNED_APP, NOC.MATERIAL.V3.MATERIAL.TARGET_ALL, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH], values: {setData: '', date: moment.fncGetMonthStr()}}, options: {minValue: true, legend: true, dataSeries: true}},
    {gadgetID: 67, title: 'アプリ利用時間グラフ（月間）', comment: COMMENT.SAMPLE67, gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.DOUGHNUT}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_APP, NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH], values: {setData: '', date: moment.fncGetMonthStr()}}, options: {minValue: true, legend: true}},

    {gadgetID: GadgetId.USER_OP_COUNT_HEATMAP_PER_YEAR, title: '操作回数ヒートマップ（年間）', comment: 'ユーザーごとの操作回数を年と時間帯ごとに集計したヒートマップ。', gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.HEATMAP}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_OP_COUNT_HEATMAP, NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.DIMENSION_MONTH, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR], values: {setData: '', date: moment.fncGetMonthStr()}}, options: {minValue: true, legend: false}},
    {gadgetID: GadgetId.USER_OP_COUNT_HEATMAP_PER_MONTH, title: '操作回数ヒートマップ（月間）', comment: 'ユーザーごとの操作回数を月と時間帯ごとに集計したヒートマップ。', gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.HEATMAP}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_OP_COUNT_HEATMAP, NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH], values: {setData: '', date: moment.fncGetMonthStr()}}, options: {minValue: true, legend: false}},
    {gadgetID: GadgetId.USER_OP_COUNT_HEATMAP_PER_DAY_OF_WEEK, title: '操作回数ヒートマップ（週間）', comment: 'ユーザーごとの操作回数を曜日と時間帯ごとに集計したヒートマップ。', gadget: GADGET_TYPE.SAMPLE, default: true, data: {now: {}, graph: [{key: NOC.CHARTS.HEATMAP}], materials: [NOC.MATERIAL.V3.MATERIAL.TYPE_SUM, NOC.MATERIAL.V3.MATERIAL.MEASURE_OP_COUNT_HEATMAP, NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.DIMENSION_DAY_OF_WEEK, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH], values: {setData: '', date: moment.fncGetMonthStr()}}, options: {minValue: true, legend: false}},

  ] as Array<IGadget<{}>>;
  // デフォルトフリーボード
  export const FREEBOARDS = [
    { freeboardID: 0, name: '従来のダッシュボード' },
    { freeboardID: 1, name: 'フリーボード2' },
    { freeboardID: 2, name: 'フリーボード3' },
  ] as IFreeboard[];
}

export namespace NOC.GADGET.ALERT {
  export const INDEX = {
    INTERVAL: 0,
    BANNED_APP: 1,
    WORK_DAY: 2,
    WORK_MONTH: 3,
    WORK_YEAR: 4,
    OVERTIME_MONTH: 5,
    AGREED_36_MONTH: 6,
    AGREED_36_YEAR: 7,
    AGREED_36_YEAR_FLEX: 8,
    LEGAL_36_MONTH_WEEK1: 9,
    LEGAL_36_YEAR_WEEK1: 10,
    LEGAL_36_MONTH_WEEK4: 11,
    LEGAL_36_YEAR_WEEK4: 12,
    LEGAL_36_YEAR_FLEX: 13,
    PCTIME_DAY: 14,
    PCTIME_MONTH: 15,
    IRREGULAR_OP: 16,
  };
  export const GADGETS = [
    // 勤務間インターバル (48H & date ~ dateto)
    { gadgetID: 0, title: '', comment: '', gadget: 'BasicGadgetV3', data: { now: {}, graph: [{ key: NOC.CHARTS.BAR }], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_DATE, NOC.MATERIAL.V3.MATERIAL.MEASURE_LOGING_TIME, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.DIMENSION_DAYS_HOUR, NOC.MATERIAL.V3.MATERIAL.FLAG_ALERT_GRAPH], values: { setData: 0, date: '' } }, options: { legend: true } },
    // 禁止アプリ (flag: banned_app)
    { gadgetID: 0, title: '', comment: '', gadget: 'BasicGadgetV3', data: { now: {}, graph: [{ key: NOC.CHARTS.STACKED_BAR }], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_DATE, NOC.MATERIAL.V3.MATERIAL.MEASURE_APP, NOC.MATERIAL.V3.MATERIAL.DIMENSION_HOUR], values: { setData: 0, date: '' } }, options: { legend: true } },
    // 実労働時間 day
    { gadgetID: 0, title: '', comment: '', gadget: 'BasicGadgetV3', data: { now: {}, graph: [{ key: NOC.CHARTS.LINE }], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_DATE, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.DIMENSION_HOUR], values: { setData: 0, date: '' } }, options: { legend: true } },
    // 実労働時間 month
    { gadgetID: 0, title: '', comment: '', gadget: 'BasicGadgetV3', data: { now: {}, graph: [{ key: NOC.CHARTS.LINE }], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE], values: { setData: 0, date: '' } }, options: { legend: true } },
    // 実労働時間 year
    { gadgetID: 0, title: '', comment: '', gadget: 'BasicGadgetV3', data: { now: {}, graph: [{ key: NOC.CHARTS.LINE }], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.DIMENSION_36_MONTH], values: { setData: 0, date: '' } }, options: { legend: true } },
    // 残業時間 month
    { gadgetID: 0, title: '', comment: '', gadget: 'BasicGadgetV3', data: { now: {}, graph: [{ key: NOC.CHARTS.LINE }], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH, NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME, NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE], values: { setData: 0, date: '' } }, options: { legend: true } },
    // 所定労働時間外 month
    { gadgetID: 0, title: '', comment: '', gadget: 'BasicGadgetV3', data: { now: {}, graph: [{ key: NOC.CHARTS.LINE }], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH, NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME_AGREED, NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE], values: { setData: 0, date: '' } }, options: { legend: true } },
    // 所定労働時間外 year
    { gadgetID: 0, title: '', comment: '', gadget: 'BasicGadgetV3', data: { now: {}, graph: [{ key: NOC.CHARTS.LINE }], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR, NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME_AGREED, NOC.MATERIAL.V3.MATERIAL.DIMENSION_36_MONTH], values: { setData: 0, date: '' } }, options: { legend: true } },
    // 所定労働時間外 year (flex)
    { gadgetID: 0, title: '', comment: '', gadget: 'BasicGadgetV3', data: { now: {}, graph: [{ key: NOC.CHARTS.LINE }], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR, NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME_AGREED_FLEX, NOC.MATERIAL.V3.MATERIAL.DIMENSION_36_MONTH], values: { setData: 0, date: '' } }, options: { legend: true } },
    // 法定労働時間外 month (1週1休 - no flex)
    { gadgetID: 0, title: '', comment: '', gadget: 'BasicGadgetV3', data: { now: {}, graph: [{ key: NOC.CHARTS.LINE }], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH, NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME_LEGAL_1, NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE], values: { setData: 0, date: '' } }, options: { legend: true } },
    // 法定労働時間外 year (1週1休 - no flex)
    { gadgetID: 0, title: '', comment: '', gadget: 'BasicGadgetV3', data: { now: {}, graph: [{ key: NOC.CHARTS.LINE }], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR, NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME_LEGAL_1, NOC.MATERIAL.V3.MATERIAL.DIMENSION_36_MONTH], values: { setData: 0, date: '' } }, options: { legend: true } },
    // 法定労働時間外 month (4週4休 - no flex)
    { gadgetID: 0, title: '', comment: '', gadget: 'BasicGadgetV3', data: { now: {}, graph: [{ key: NOC.CHARTS.LINE }], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH, NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME_LEGAL_4, NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE], values: { setData: 0, date: '' } }, options: { legend: true } },
    // 法定労働時間外 year (4週4休 - no flex)
    { gadgetID: 0, title: '', comment: '', gadget: 'BasicGadgetV3', data: { now: {}, graph: [{ key: NOC.CHARTS.LINE }], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR, NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME_LEGAL_4, NOC.MATERIAL.V3.MATERIAL.DIMENSION_36_MONTH], values: { setData: 0, date: '' } }, options: { legend: true } },
    // 法定労働時間外 year (flex)
    { gadgetID: 0, title: '', comment: '', gadget: 'BasicGadgetV3', data: { now: {}, graph: [{ key: NOC.CHARTS.LINE }], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_YEAR, NOC.MATERIAL.V3.MATERIAL.MEASURE_OVER_TIME_LEGAL_FLEX, NOC.MATERIAL.V3.MATERIAL.DIMENSION_36_MONTH], values: { setData: 0, date: '' } }, options: { legend: true } },
    // 就業時間 day
    { gadgetID: 0, title: '', comment: '', gadget: 'BasicGadgetV3', data: { now: {}, graph: [{ key: NOC.CHARTS.BAR }], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_DATE, NOC.MATERIAL.V3.MATERIAL.MEASURE_LOGING_TIME, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.DIMENSION_HOUR, NOC.MATERIAL.V3.MATERIAL.FLAG_ALERT_GRAPH], values: { setData: 0, date: '' } }, options: { legend: true } },
    // 就業時間 month
    { gadgetID: 0, title: '', comment: '', gadget: 'BasicGadgetV3', data: { now: {}, graph: [{ key: NOC.CHARTS.BAR }], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_MONTH, NOC.MATERIAL.V3.MATERIAL.MEASURE_LOGING_TIME, NOC.MATERIAL.V3.MATERIAL.MEASURE_WORKING_TIME, NOC.MATERIAL.V3.MATERIAL.DIMENSION_DATE, NOC.MATERIAL.V3.MATERIAL.FLAG_ALERT_GRAPH], values: { setData: 0, date: '' } }, options: { legend: true } },
    // 異常操作通知
    { gadgetID: 0, title: '', comment: '', gadget: 'BasicGadgetV3', data: { now: {}, graph: [{ key: NOC.CHARTS.LINE }], materials: [NOC.MATERIAL.V3.MATERIAL.TARGET_MEMBER, NOC.MATERIAL.V3.MATERIAL.TARGET_DATE, NOC.MATERIAL.V3.MATERIAL.MEASURE_COUNT, NOC.MATERIAL.V3.MATERIAL.DIMENSION_HOUR, NOC.MATERIAL.V3.MATERIAL.FLAG_ALERT_GRAPH], values: { setData: 0, date: '' } }, options: { legend: true } },
  ] as Array<IGadget<{}>>;
}

export namespace NOC.INPUT.TYPE {
  export const TEXT = 'text';
  export const NUMBER = 'number';
  export const TIME = 'time';
  export const DATE = 'date';
  export const RADIO = 'radio';
  export const SELECT = 'select';
  export const TEXTAREA = 'textarea';
  export const PASSWORD = 'password';
}


import {IOptionValue} from '../../models/typed/gadget/basicGadget';

export namespace NOC.OPTION.V1 {
  export namespace KEY {
    export const COLOR = 'color';
    export const MIN_VALUE = 'minValue';
    export const DATE = 'displayDate';
    export const LEGEND = 'legend';
    export const MULTI_DOUGHNUT = 'multiDoughnut';
    export const DATA_SERIES = 'dataSeries';
    export const CHANGE_PULLDOWN = 'changepulldown';
  }
  export interface OptionType {
    key: string;
    label: string;
    charts: string[];
    materials: number[];
    type: string;
    default: string | boolean;
    // values: Array<{text: string; value: string | boolean}>;
    values: Array<{text: string; value: string | boolean; display?: boolean}>;
  }
  export namespace OPTION {
    export const COLOR: OptionType = {key: KEY.COLOR , label: 'カラー', charts: [ NOC.CHARTS.BAR, NOC.CHARTS.HORIZONTALBAR, NOC.CHARTS.PIE, NOC.CHARTS.DOUGHNUT ], materials: [12], type: NOC.INPUT.TYPE.NUMBER, default: '1', values: [ {text: '単色', value: '1', display: true}, {text: 'カラフル', value: '2', display: true}, {text: '赤', value: '3', display: true}, {text: '青', value: '4', display: true}, {text: '緑', value: '5', display: true} ]};
    // export const COLOR: OptionType = {key: KEY.COLOR , label: 'カラー', charts: [ NOC.CHARTS.BAR, NOC.CHARTS.HORIZONTALBAR, NOC.CHARTS.PIE, NOC.CHARTS.DOUGHNUT ], materials: [12], type: NOC.INPUT.TYPE.NUMBER, default: '1', values: [ {text: '単色', value: '1'}, {text: 'カラフル', value: '2'}, {text: '赤', value: '3'}, {text: '青', value: '4'}, {text: '緑', value: '5'} ]};
    // export const COLOR: OptionType = {key: KEY.COLOR , label: 'カラー', charts: [ NOC.CHARTS.BAR, NOC.CHARTS.HORIZONTALBAR, NOC.CHARTS.PIE, NOC.CHARTS.DOUGHNUT ], materials: [12], type: NOC.INPUT.TYPE.RADIO, default: false, values: [ {text: '単色', value: false}, {text: 'パターン1', value: true}]};
    export const MIN_VALUE: OptionType = {key: KEY.MIN_VALUE , label: '最小値', charts: [ NOC.CHARTS.ALL ], materials: [7, 8, 19, 20, 59, 60], type: NOC.INPUT.TYPE.RADIO, default: false, values: [{text: '自動', value: false}, {text: '0', value: true}]};
    export const DATE: OptionType = {key: KEY.DATE , label: '日付設定', charts: [ NOC.CHARTS.ALL ], materials: [7, 8, 19, 20], type: NOC.INPUT.TYPE.RADIO, default: 'date', values: [{text: '日付', value: 'date'}, {text: '選択', value: 'chose'}]};
    export const LEGEND: OptionType = {key: KEY.LEGEND , label: '凡例', charts: [ NOC.CHARTS.DOUGHNUT, NOC.CHARTS.PIE ], materials: [12], type: NOC.INPUT.TYPE.RADIO, default: false, values: [{text: '非表示', value: false}, {text: '表示', value: true}]};

    // export const CHANGE_PULLDOWN: OptionType = {key: KEY.CHANGE_PULLDOWN , label: 'プルダウン選択', charts: [ NOC.CHARTS.ALL ], materials: [12], type: NOC.INPUT.TYPE.RADIO, default: false, values: [{text: 'グループ', value: false}, {text: '部署', value: true}]};
  }

  const OPTIONS = [
    OPTION.COLOR,
    OPTION.MIN_VALUE,
    OPTION.DATE ,
    OPTION.LEGEND,
    // OPTION.CHANGE_PULLDOWN,
  ];

  export const createChoices = ((graph: string, materials: IMaterial[], options: OptionType[] = OPTIONS) => {
    // console.log('createChoices', graph, materials );
    // console.log(OPTIONS[0].charts.indexOf(graph));
    // console.log(OPTIONS.filter((v) => (v.charts.indexOf(graph) >= 0)));
    // console.log('materials', materials);
    const materialIDs = materials.map((v) => (v.id));
    // console.log(materialIDs.indexOf(12));
    return options.filter(
      (v) => (
        (v.charts.indexOf(graph) >= 0 || v.charts.indexOf(NOC.CHARTS.ALL) >= 0)
        && (v.materials.filter((id) => (materialIDs.indexOf(id) >= 0)).length > 0 || v.materials[0] === 0)
      ),
    );
  });

  export const createOptions = ((froms: any, items: any) => {
    const returnObj = {} as any;
    for (const option of items) {
      // fromsに値がある場合は受け継ぐ
      if (option.key in froms) {
        returnObj[option.key] = froms[option.key];
      } else {
        returnObj[option.key] = option.default;
      }
    }
    return returnObj;
  });

  export const getValues = ((v: any, key: string) => {
    if (key in v) {
      // console.log(v[key])
      return v[key];
    } else {
      return undefined;
    }
  });

}

export namespace NOC.OPTION.V2 {
  import key_v1 = NOC.OPTION.V1.KEY;
  import option_v1 = NOC.OPTION.V1.OPTION;
  import option_type = NOC.OPTION.V1.OptionType;

  export const KEY = key_v1;
  export const changeProps = (option: option_type, callback: (opt: option_type) => void) => {
    const copied = JSON.parse(JSON.stringify(option));
    callback(copied);
    return copied;
  };
  export namespace OPTION {
    // note takezawa 各オプションを適用するMATERIAL IDをここに記載している模様。
    export const COLOR: option_type = changeProps(option_v1.COLOR, (opt) => {
      opt.charts = opt.charts.concat([ NOC.CHARTS.STACKED_BAR, NOC.CHARTS.STACKED_HORIZONTALBAR, NOC.CHARTS.LINE]);
    });
    export const MIN_VALUE: option_type = changeProps(option_v1.MIN_VALUE, (opt) => {
      opt.default = true; // デフォルト：最小値0
      opt.materials = opt.materials.concat([11, 23, 24, 36, 37, 38, 39, 40, 41, 42, 48, 49, 50, 51, 52]);
    });
    // note takezawa このオプションはグラフの表示日時を月/日付ピッカーで選択できるようにする。
    export const DATE: option_type = changeProps(option_v1.DATE, (opt) => {
      // note takezawa DATEオプション(displayDate)を有効にするMATERIAL IDをここに記載している模様。
      opt.materials = opt.materials.concat([11, 23, 24, 36, 37, 38, 39, 40, 41, 42, 48, 49, 50, 51, 52, 56, 57, 58, 59, 62]);
    });
    export const LEGEND: option_type = changeProps(option_v1.LEGEND, (opt) => {
      opt.default = true; // デフォルト：凡例表示
      opt.charts = [ NOC.CHARTS.ALL ];
      opt.materials = [12, 15, 16, 17, 18, 44, 46, 47];
    });
    export const MULTI_DOUGHNUT: option_type = { // 新規追加（デフォルト：時間表示）
      key: KEY.MULTI_DOUGHNUT, label: '円グラフ', charts: [ NOC.CHARTS.DOUGHNUT, NOC.CHARTS.PIE ],
      materials: [12], type: NOC.INPUT.TYPE.RADIO, default: false, values: [{text: '時間表示', value: false}, {text: '人数表示', value: true}],
    };
    export const DATA_SERIES: option_type = { // 新規追加（デフォルト：データ）
      key: KEY.DATA_SERIES, label: 'データ系列',
      charts: [ NOC.CHARTS.BAR, NOC.CHARTS.HORIZONTALBAR, NOC.CHARTS.LINE, NOC.CHARTS.STACKED_BAR, NOC.CHARTS.STACKED_HORIZONTALBAR, NOC.CHARTS.LIST ],
      materials: [22, 54], type: NOC.INPUT.TYPE.RADIO, default: false, values: [{text: 'データ', value: false}, {text: 'ユーザー', value: true}],
    };
    export const CHANGE_PULLDOWN: option_type = { // 新規追加（デフォルト：グループ）
      key: KEY.CHANGE_PULLDOWN, label: 'プルダウン選択',
      charts: [ NOC.CHARTS.ALL ],
      materials: [22], type: NOC.INPUT.TYPE.RADIO, default: false, values: [{text: 'グループ', value: false}, {text: '部署', value: true}],
    };

    // export const CHANGE_PULLDOWN: option_type = changeProps(option_v1.LEGEND, (opt) => {
    //   opt.default = true; // デフォルト：凡例表示
    //   opt.charts = [ NOC.CHARTS.ALL ];
    //   opt.materials = [];
    // });


  }
  const OPTIONS = [OPTION.COLOR, OPTION.MIN_VALUE, OPTION.DATE, OPTION.LEGEND, OPTION.MULTI_DOUGHNUT, OPTION.DATA_SERIES, OPTION.CHANGE_PULLDOWN];
  export const createChoices = ((graph: string, materials: IMaterial[]) => {
    return NOC.OPTION.V1.createChoices(graph, materials, OPTIONS);
  });
  export const createOptions = NOC.OPTION.V1.createOptions;
  export const getValues = NOC.OPTION.V1.getValues;
}

export namespace NOC.WELCOME.MODE {
  export const MAIN = 'WelcomeMain';
  export const FLOW = 'WelcomeFlow';
  export const FUNCTION = 'WelcomeFunction';
  export const PLAN = 'WelcomePlan';
  export const QUESTION = 'WelcomeQuestion';
}

export namespace NOC.NEWS {
  export interface ICategory {
    title: string;
    type: string;
    icon: string;
    background: string;
    color: string;
  }
  export const CATEGORY: ICategory[] = [
    {
      title: 'お知らせ',
      type: 'information',
      icon: 'fa-info-circle',
      background: '#DCE5F8',
      color: '#182863',
    },
    {
      title: 'メンテナンス',
      type: 'maintenance',
      icon: 'fa-wrench',
      background: '#DCE5F8',
      color: '#182863',
    },
    {
      title: 'アップデート',
      type: 'update',
      icon: 'fa-plus',
      background: '#DCE5F8',
      color: '#182863',
    },
    {
      title: '障害情報',
      type: 'failure',
      icon: 'fa-exclamation-triangle',
      background: '#DCE5F8',
      color: '#182863',
    },
  ];
}

export namespace NOC.ALERT {
  export namespace TYPE {
    export const OVERTIME = 1;
    export const INTERVAL = 2;
    export const AGREEMENT_36_PARENT = 10;
    export const DAY_36 = 11;
    export const MONTH_36 = 12;
    export const YEAR_36 = 13;
    export const BANNED_APP = 90;
    export const MONTHLY_REPORT = 100;
    export const MONTHLY_REPORT_101 = 101;  // note takezawa この番号は使用しているようなので定義。詳細は未調査。
    export const MONTHLY_REPORT_102 = 102;  // note takezawa この番号は使用しているようなので定義。詳細は未調査。
    export const MONTHLY_REPORT_103 = 103;  // note takezawa この番号は使用しているようなので定義。詳細は未調査。
    export const MONTHLY_REPORT_104 = 104;  // note takezawa この番号は使用しているようなので定義。詳細は未調査。
    export const MONTHLY_REPORT_105 = 105;  // note takezawa この番号は使用しているようなので定義。詳細は未調査。
    export const IRREGULAR_OP = 110;  // 異常操作回数通知
    // アラート追加対応
    export const ORDINARY_AGREED_DAY = 31;
    export const ORDINARY_LEGAL_DAY = 32;
    export const ORDINARY_AGREED_MONTH = 33;
    export const ORDINARY_LEGAL_MONTH = 34;
    export const ORDINARY_AGREED_YEAR = 35;
    export const ORDINARY_LEGAL_YEAR = 36;
    export const SPECIAL_AGREED_DAY = 41;
    export const SPECIAL_LEGAL_DAY = 42;
    export const SPECIAL_AGREED_MONTH = 43;
    export const SPECIAL_LEGAL_MONTH = 44;
    export const SPECIAL_LEGAL_MONTH_COUNT = 45;
    export const SPECIAL_AGREED_YEAR = 46;
    export const SPECIAL_LEGAL_YEAR = 47;
  }
  // アラート追加対応　メールは過去分の表示がないためコメントアウト
  /*export namespace MAIL_MESSAGE {
    export const OVERTIME = '以下のユーザーは残業時間が@時間を超過しました。';
    export const INTERVAL = '以下のユーザーは勤務間インターバルが@時間未満でした。';
    export const DAY_36 = '以下のユーザーは1日の労働時間が@時間を超過しました。';
    export const MONTH_36 = '以下のユーザーは1ヶ月の労働時間が@時間を超過しました。';
    export const YEAR_36 = '以下のユーザーは1年の労働時間が@時間を超過しました。';
    export const BANNED_APP = '以下のユーザーは禁止アプリケーションを使用しました。';
  }*/
  export namespace TITLE {
    export const OVERTIME = '@ さんの残業時間が指定時間を超えました。';
    export const INTERVAL = '@ さんの勤務間インターバルが指定時間を下回りました。';
    export const AGREEMENT_36 = '@ さんが36協定通知の上限を超えました。';
    export const BANNED_APP = '@ さんが禁止アプリを使用しました。';
    export const MONTHLY_REPORT = '@分の月間レポート';
    export const IRREGULAR_OP = '異常な操作を検出しました。@ さんが異常操作回数を超えました。';
  }
  export namespace MESSAGE {
    export const OVERTIME = '@0 さんの@1の残業時間は@2時間でした。\\n設定された@3時間を超過しています。';
    export const INTERVAL = '@0 さんの@1の勤務間インターバルは@2時間でした。\\n設定された@3時間を下回っています。';
    export const DAY_36 =   '@0 さんの@1の労働時間は@2時間でした。\\n設定された@3時間を超過しています。';
    export const MONTH_36 = '@0 さんの@1～@2の労働時間は@3時間でした。\\n設定された@4時間を超過しています。';
    export const YEAR_36 =  '@0 さんの@1～@2の労働時間は@3時間でした。\\n設定された@4時間を超過しています。';
    export const BANNED_APP = '@0 さんは@1に以下の禁止アプリを使用しました。';
    export const IRREGULAR_OP = '@0 さんが異常操作回数を超えました。';
    // アラート追加対応
    export const AGREED_DAY = '@0 さんの@1の所定労働時間外は@2時間でした。\\n設定された@3時間を超過しています。';
    export const AGREED_TERM = '@0 さんの@1～@2の所定労働時間外は@3時間でした。\\n設定された@4時間を超過しています。';
    export const LEGAL_DAY = '@0 さんの@1の法定労働時間外は@2時間でした。\\n設定された@3時間を超過しています。';
    export const LEGAL_TERM = '@0 さんの@1～@2の法定労働時間外は@3時間でした。\\n設定された@4時間を超過しています。';
    export const LEGAL_OVER_COUNT = '@0 さんが@1～@2に1ヶ月の法定労働時間外が@3時間を超えた回数は@4回でした。\\n設定された@5回を超過しています。';
  }
  export const returnTitle = ((type: number, userName: string) => {
    let title = '';
    switch (type) {
      case TYPE.OVERTIME:
        title = TITLE.OVERTIME;
        break;
      case TYPE.INTERVAL:
        title = TITLE.INTERVAL;
        break;
      case TYPE.AGREEMENT_36_PARENT:
        title = TITLE.AGREEMENT_36;
        break;
      case TYPE.BANNED_APP:
        title = TITLE.BANNED_APP;
        break;
      case TYPE.MONTHLY_REPORT:
        title = TITLE.MONTHLY_REPORT;
        break;
      case TYPE.IRREGULAR_OP:
        title = TITLE.IRREGULAR_OP;
        break;
    }
    title = title.replace('@', userName);
    return title;
  });
  export const returnMessage = ((type: number, ...value: string[]) => {
    let message = '';
    switch (type) {
      // 長時間残業
      case TYPE.OVERTIME:
        message = MESSAGE.OVERTIME;
        break;
      // 勤務間インターバル
      case TYPE.INTERVAL:
        message = MESSAGE.INTERVAL;
        break;
      // 36協定
      case TYPE.DAY_36:
        message = MESSAGE.DAY_36;
        break;
      case TYPE.MONTH_36:
        message = MESSAGE.MONTH_36;
        break;
      case TYPE.YEAR_36:
        message = MESSAGE.YEAR_36;
        break;
      // 所定・1日
      case TYPE.ORDINARY_AGREED_DAY:
      case TYPE.SPECIAL_AGREED_DAY:
        message = MESSAGE.AGREED_DAY;
        break;
      // 法定・1日
      case TYPE.ORDINARY_LEGAL_DAY:
      case TYPE.SPECIAL_LEGAL_DAY:
        message = MESSAGE.LEGAL_DAY;
        break;
      // 所定・期間
      case TYPE.ORDINARY_AGREED_MONTH:
      case TYPE.ORDINARY_AGREED_YEAR:
      case TYPE.SPECIAL_AGREED_MONTH:
      case TYPE.SPECIAL_AGREED_YEAR:
        message = MESSAGE.AGREED_TERM;
        break;
      // 法定・期間
      case TYPE.ORDINARY_LEGAL_MONTH:
      case TYPE.ORDINARY_LEGAL_YEAR:
      case TYPE.SPECIAL_LEGAL_MONTH:
      case TYPE.SPECIAL_LEGAL_YEAR:
        message = MESSAGE.LEGAL_TERM;
        break;
      // 法定・回数
      case TYPE.SPECIAL_LEGAL_MONTH_COUNT:
        message = MESSAGE.LEGAL_OVER_COUNT;
        break;
      // 禁止アプリ
      case TYPE.BANNED_APP:
        message = MESSAGE.BANNED_APP;
        break;
      // 異常操作回数
      case TYPE.IRREGULAR_OP:
        message = MESSAGE.IRREGULAR_OP;
        break;
    }
    value.forEach((v, i) => {
      message = message.replace(`@${i}`, v);
    });
    return message;
  });
  /*export const returnMailMessage = ((type?: number, settingValue?: string) => {
    let message = '';
    const value = settingValue ? JSON.parse(settingValue) : '';
    switch (type) {
      case TYPE.OVERTIME:
        message = MAIL_MESSAGE.OVERTIME;
        break;
      case TYPE.INTERVAL:
        message = MAIL_MESSAGE.INTERVAL;
        break;
      case TYPE.DAY_36:
        message = MAIL_MESSAGE.DAY_36;
        break;
      case TYPE.MONTH_36:
        message = MAIL_MESSAGE.MONTH_36;
        if (typeof value === 'object' && (value as object).hasOwnProperty('permonth_limit')) {
          value = value.permonth_limit;
        }
        break;
      case TYPE.YEAR_36:
        message = MAIL_MESSAGE.YEAR_36;
        if (typeof value === 'object' && (value as object).hasOwnProperty('peryear_limit')) {
          value = value.peryear_limit;
        }
        break;
      case TYPE.BANNED_APP:
        message = MAIL_MESSAGE.BANNED_APP;
        break;
    }
    if (value || value === 0) {
      message = message.replace('@', value);
    }
    return message;
  });*/
}

// select options
import { ISelectOption as IOption} from '@/class/models/typed/wild';

export namespace NOC.JOB {
  export namespace VALUE {
    export const DEFAULT = 0;
    export const SALES = 1;
    export const OFFICE = 2;
    export const PLAN = 3;
    export const MANAGEMENT = 4;
    export const DESIGN = 5;
    export const CONSUL = 6;
    export const ENGINEER = 7;
    export const BILL = 8;
    export const SERVANT = 9;
  }
  // アルファベット名
  export namespace KEY {
    export const DEFAULT = 'DEFAULT';
    export const SALES = 'SALES';
    export const OFFICE = 'OFFICE';
    export const PLAN = 'PLAN';
    export const MANAGEMENT = 'MANAGEMENT';
    export const DESIGN = 'DESIGN';
    export const CONSUL = 'CONSUL';
    export const ENGINEER = 'ENGINEER';
    export const BILL = 'BILL';
    export const SERVANT = 'SERVANT';
  }
  export namespace TEXT {
    export const DEFAULT = '一般職';
    export const SALES = '営業';
    export const OFFICE = '事務・管理';
    export const PLAN = '企画・マーケティング';
    export const MANAGEMENT = '経営・管理職';
    export const DESIGN = 'デザイナー';
    export const CONSUL = 'コンサルタント・士業';
    export const ENGINEER = 'エンジニア・研究職';
    export const BILL = '建築・土木技術職';
    export const SERVANT = '公務員';
  }
  export const JOBArray = [
    {key: KEY.DEFAULT, text: TEXT.DEFAULT, value: VALUE.DEFAULT },
    {key: KEY.SALES, text: TEXT.SALES, value: VALUE.SALES },
    {key: KEY.OFFICE, text: TEXT.OFFICE, value: VALUE.OFFICE },
    {key: KEY.PLAN, text: TEXT.PLAN, value: VALUE.PLAN },
    {key: KEY.MANAGEMENT, text: TEXT.MANAGEMENT, value: VALUE.MANAGEMENT },
    {key: KEY.DESIGN, text: TEXT.DESIGN, value: VALUE.DESIGN },
    {key: KEY.CONSUL, text: TEXT.CONSUL, value: VALUE.CONSUL },
    {key: KEY.ENGINEER, text: TEXT.ENGINEER, value: VALUE.ENGINEER },
    {key: KEY.BILL, text: TEXT.BILL, value: VALUE.BILL },
    {key: KEY.SERVANT, text: TEXT.SERVANT, value: VALUE.SERVANT },
  ];
  export namespace COUNT {
    export const DEFAULT = 600;
    export const SALES = 150;
    export const OFFICE = 150;
    export const PLAN = 150;
    export const MANAGEMENT = 300;
    export const DESIGN = 300;
    export const CONSUL = 300;
    export const ENGINEER = 450;
    export const BILL = 300;
    export const SERVANT = 300;
  }
  export const oldJOBArray = [
    {text: TEXT.DEFAULT, value: VALUE.DEFAULT, count: COUNT.DEFAULT },
    {text: TEXT.SALES, value: VALUE.SALES, count: COUNT.SALES },
    {text: TEXT.OFFICE, value: VALUE.OFFICE, count: COUNT.OFFICE },
    {text: TEXT.PLAN, value: VALUE.PLAN, count: COUNT.PLAN },
    {text: TEXT.MANAGEMENT, value: VALUE.MANAGEMENT, count: COUNT.MANAGEMENT },
    {text: TEXT.DESIGN, value: VALUE.DESIGN, count: COUNT.DESIGN },
    {text: TEXT.CONSUL, value: VALUE.CONSUL, count: COUNT.CONSUL },
    {text: TEXT.ENGINEER, value: VALUE.ENGINEER, count: COUNT.ENGINEER },
    {text: TEXT.BILL, value: VALUE.BILL, count: COUNT.BILL },
    {text: TEXT.SERVANT, value: VALUE.SERVANT, count: COUNT.SERVANT },
  ];
  export function getCount(value: number) {
    let returnCount = 600;
    const job = oldJOBArray.find((v) => (v.value === value));
    if (job) {
      returnCount = job.count;
    }
    return returnCount;
  }
}

export namespace NOC.SURVEY {
  // 調査番号
  export namespace SURVEY_NUMBERS {
    export const GRAPH_ADDITION = 1;
  }
  // デザインバージョン
  export namespace VERSIONS {
    export const UNDEFINED = 0;
    export const SECOND = 2;
    export const THIRD = 3; // 第三次デザイン
  }
  // 最新の調査番号
  export const LATEST = SURVEY_NUMBERS.GRAPH_ADDITION;
}

export namespace NOC.LEGAL_WORK {
  // 法定労働時間の総枠
  const HOURS_DEFINITION = { 28: 160.0, 29: 165.7, 30: 171.4, 31: 177.1 };
  export const FIXED_HOURS = (dayCount: number) => {
    let hours = 0;
    switch (dayCount) {
      case 28:
      case 29:
      case 30:
      case 31:
        hours = HOURS_DEFINITION[dayCount];
        break;
      default: {
        // 40時間×歴日数÷7で小数点以下2桁で切り捨て
        hours = Math.floor(400 * dayCount / 7) / 10;
        break;
      }
    }
    return hours;
  };
}

export namespace NOC.PREFECTURE {
  // JIS X 0401: 01～47
  export const LIST = [
    NOC.SELECT.NOSELECT.text,
    '北海道', '青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県',
    '茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県',
    '新潟県', '富山県', '石川県', '福井県', '山梨県', '長野県', '岐阜県', '静岡県', '愛知県',
    '三重県', '滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県',
    '鳥取県', '島根県', '岡山県', '広島県', '山口県',
    '徳島県', '香川県', '愛媛県', '高知県',
    '福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県', '沖縄県',
  ];
  export function getPrefecture(value?: number): string {
    return value && value < 48 ? LIST[value] : '';
  }
  export function getOptions(): IOption[] {
    return LIST.map((v, i) => ({ text: v, value: i }));
  }
}

export namespace NOC.CSV {
  // テンプレート1行目のCSV識別子
  export namespace KEY {
    export const ADD_USER = 'RLDI0001_USER';
    export const ADD_DEPARTMENT = 'RLDI0001_DEP';
    export const RELATE_USER = 'RLDI0001_REL_USER';
  }
  // CSVインポート種類名
  export namespace NAME {
    export const ADD_USER = 'ユーザー登録';
    export const ADD_DEPARTMENT = '部署登録';
    export const RELATE_USER = '関連付け';
  }
  export const MAP: {[key: string]: string} = {
    [KEY.ADD_USER]: NAME.ADD_USER,
    [KEY.ADD_DEPARTMENT]: NAME.ADD_DEPARTMENT,
    [KEY.RELATE_USER]: NAME.RELATE_USER,
  };

  export namespace HEADER {
    export const ADD_USER = [
      { column: 'sei', name: '姓', required: true },
      { column: 'mei', name: '名', required: true },
      { column: 'sei_kana', name: '姓(カナ)', required: true },
      { column: 'mei_kana', name: '名(カナ)', required: true },
      { column: 'role', name: '権限', required: true, type: 'number', nameColumns: [{ column: 'role_name', name: '権限' }] },
      { column: 'mail', name: 'メールアドレス' },
      { column: 'birthday', name: '生年月日' },
      { column: 'gender', name: '性別', type: 'number', nameColumns: [{ column: 'gender_name', name: '性別' }] },
      { column: 'workstyle_id', name: '就業形態ID', required: true, type: 'number', nameColumns: [{ column: 'workstyle_name', name: '就業形態名' }] },
      { column: 'job', name: '職種', required: true, type: 'number', nameColumns: [{ column: 'job_name', name: '職種' }] },
      { column: 'flextime', name: 'フレックスタイム', required: true, type: 'number', nameColumns: [{ column: 'flextime_name', name: 'フレックスタイム' }] },
      { column: 'department_id', name: '部署ID', required: true, type: 'number', nameColumns: [{ column: 'department_name', name: '部署名' }] },
      { column: 'device_id', name: '端末ID', type: 'number',
        nameColumns: [{ column: 'computer_name', name: 'コンピュータ名' }, { column: 'pc_account_name', name: 'PCアカウント名' } ] },
      { column: 'manager_user_id', name: '労務管理者ユーザーID', type: 'number', nameColumns: [{ column: 'manager_user_name', name: '労務管理者ユーザー名' }] },
      { column: 'workmanage_id', name: '業務ID', type: 'number', nameColumns: [{ column: 'work_name', name: '業務名' }] },
    ];
    export const ADD_DEPARTMENT = [
      { column: 'department_name', name: '部署名', required: true },
      { column: 'parent_id', name: '親部署ID', type: 'number', nameColumns: [{ column: 'parent_name', name: '親部署名' }] },
      { column: 'workmanage_id', name: '業務ID', type: 'number', nameColumns: [{ column: 'work_name', name: '業務名' }] },
      // { column: 'workstyle_id', name: '就業形態ID', type: 'number', nameColumns: [{ column: 'workstyle_name', name: '就業形態名' }] },
      // { column: 'flextime', name: 'フレックスタイム', required: true, type: 'number', nameColumns: [{ column: 'flextime_name', name: 'フレックスタイム' }] },
      { column: 'manager_user_id', name: '労務管理者ユーザーID', type: 'number', nameColumns: [{ column: 'manager_user_name', name: '労務管理者ユーザー名' }] },
    ];
    export const RELATE_USER = [
      { column: 'user_id', name: 'ユーザーID', required: true, type: 'number', nameColumns: [{ column: 'user_name', name: 'ユーザー名' }] },
      { column: 'department_id', name: '部署名', type: 'number', nameColumns: [{ column: 'department_name', name: '部署名' }] },
      { column: 'device_id', name: '端末ID', type: 'number',
        nameColumns: [{ column: 'computer_name', name: 'コンピュータ名' }, { column: 'pc_account_name', name: 'PCアカウント名' } ] },
      { column: 'manager_user_id', name: '労務管理者ユーザーID', type: 'number', nameColumns: [{ column: 'manager_user_name', name: '労務管理者ユーザー名' }] },
      { column: 'workmanage_id', name: '業務ID', type: 'number', nameColumns: [{ column: 'work_name', name: '業務名' }] },
    ];
  }
}
